export const translations = {
  en: {
    nav: {
      clinic: 'Clinic',
      astonVilla: 'Aston Villa',
      englishImmersion: 'Full English Immersion',
      technology: 'Technology & Analysis',
      aboutOakham: 'About Oakham',
      prices: 'Prices',
      contact: 'Contact',
      signUp: 'Sign Up Now'
    },
    hero: {
      badge: '20+ Years of Excellence',
      title: 'Elite Football Camps in Oakham, England',
      subtitle: 'Two exceptional programs. One world-class location. 20+ years of excellence.',
      exploreProgramsBtn: 'Explore Programs',
      viewPricesBtn: 'View Prices'
    },
    home: {
      tech: {
        badge: 'Cutting-Edge Technology',
        title: 'Train Smarter with Technology',
        subtitle: 'We use the latest technology to track, analyze, and accelerate your football development',
        veoTitle: 'Veo Camera System',
        veoDesc: 'Professional match recording with AI-powered analysis and automatic highlights',
        draftTitle: 'The Draft App',
        draftDesc: 'AI-powered assessment of physical and technical abilities with age-appropriate benchmarking',
        reportsTitle: 'Evaluation Reports',
        reportsDesc: 'Comprehensive multi-page analysis with personalized recommendations for continued development',
        cta: 'Explore Our Technology'
      }
    },
    programs: {
      title: 'Choose Your Program',
      subtitle: 'Two world-class football programs at the heart of England. Both offering elite training, English immersion, and unforgettable experiences.',
      from: 'From',
      viewDetails: 'View Program Details',
      learnMore: 'Learn More'
    },
    footer: {
      about: 'Premier football and English language summer camps in the heart of England.',
      contact: 'Contact',
      legal: 'Legal',
      quickLinks: 'Quick Links',
      terms: 'Terms & Conditions',
      privacyPolicy: 'Privacy Policy',
      cookiePolicy: 'Cookie Policy',
      copyright: '© 2026 Oakham Football Camps. All rights reserved.',
      ctaTitle: 'Ready to Start Your Football Journey?',
      ctaSubtitle: 'Join hundreds of young players who have transformed their skills at England\'s premier football academy',
      getQuote: 'Get a Quote',
      contactUs: 'Contact Us'
    },
    programs: {
      title: 'Choose Your Program',
      subtitle: 'Two world-class football programs at the heart of England. Both offering elite training, English immersion, and unforgettable experiences.',
      from: 'From',
      viewDetails: 'View Program Details',
      learnMore: 'Learn More',
      comingSoon: 'Coming Soon',
      // Program cards data
      clinic: {
        name: 'High Performance Clinic',
        tagline: 'Elite training with top European academy coaches',
        highlights: [
          'UEFA licensed coaches from top European academies',
          'English language immersion (4.5 hours daily)',
          'High-intensity training (4.5/5)',
          'Ages 11-17, boys only',
          'Individual skill development focus'
        ]
      },
      astonVilla: {
        name: 'Aston Villa Foundation Program',
        tagline: 'Official Aston Villa Foundation coaching in England',
        highlights: [
          'Official Aston Villa Foundation coaches',
          '20 hours training + 8 hours workshops per week',
          'English language classes (7.5 hours/week)',
          'Ages 10-17, all levels welcome',
          'Premier League stadium excursion'
        ]
      }
    },
    whyOakham: {
      title: 'Why Train at Oakham?',
      subtitle: 'Over 20 years of excellence in youth football development',
      reasons: [
        {
          title: '20+ Years Experience',
          description: 'Two decades of successfully developing young footballers from around the world'
        },
        {
          title: 'Perfect Location',
          description: 'Historic town in the heart of England, 2 hours from London, safe and welcoming environment'
        },
        {
          title: 'International Community',
          description: 'Welcome players from over 30 countries, creating a truly global football experience'
        },
        {
          title: 'Premium Facilities',
          description: 'World-class training pitches, modern accommodation, and excellent dining at Oakham School'
        }
      ]
    },
    activities: {
      title: 'Stadium Visits & Activities',
      subtitle: 'Experience English football culture beyond the training pitch',
      stadiumVisits: [
        {
          name: 'Wembley Stadium',
          description: 'Visit England\'s iconic national stadium'
        },
        {
          name: 'Premier League Stadiums',
          description: 'Experience the home of top English clubs'
        }
      ],
      freetimeTitle: 'Free Time Activities',
      freetimeActivities: [
        'Swimming in Olympic-size pool',
        'Games room with pool table and ping-pong',
        'PlayStation and TV lounge',
        'Gymnasium access',
        'Evening football presentations',
        'Team-building activities'
      ]
    },
    testimonials: {
      title: 'What Parents Say',
      subtitle: 'Hear from families who have experienced our camps',
      items: [
        {
          name: 'Brenda',
          role: 'Mother of Jerónimo C. G., 15 years old',
          country: 'Spain',
          text: 'Everything was great. My son was very happy spending time there and learning. To sum it up in one word: excellent. I think the camp has everything the kids need to be happy – learning and enjoying themselves.',
          program: 'High Performance Clinic'
        },
        {
          name: 'Nouf',
          role: 'Father of Zayed A., 13 years old',
          country: 'United Kingdom',
          text: 'A great experience, a fast response, quick, and professional. Eduard the supervisor at the camp was very supportive and helpful.',
          program: 'High Performance Clinic'
        },
        {
          name: 'Dolores',
          role: 'Mother of Oriol N. P., 18 years old',
          country: 'Spain',
          text: 'The experience was amazing! We definitely plan to return, and if it were up to our son, he would stay all year round! 10 out of 10!',
          program: 'High Performance Clinic'
        },
        {
          name: 'Giuliana T.',
          role: 'Mother of Riccardo Z., 17 years old',
          country: 'Italy',
          text: 'It was a wonderful experience for Riccardo, he met a lot of people and was able to speak many languages with people from different European countries.',
          program: 'High Performance Clinic'
        }
      ]
    },
    clinic: {
      heroTitle: 'High Performance Clinic',
      heroSubtitle: 'Elite football training with top European academy coaches and complete English immersion',
      viewPrices: 'View Prices',
      signUpNow: 'Sign Up Now',
      programOverview: 'Program Overview',
      programOverviewDesc: 'Professional-style training designed for advanced/elite players with solid technique and advanced game intelligence. Train with UEFA licensed coaches from top European academies.',
      ages: 'Ages',
      duration: 'Duration',
      intensity: 'Intensity',
      english: 'English',
      weeks: 'Weeks',
      hrsDay: 'hrs/day',
      programAtGlance: 'Program at a Glance',
      programAtGlanceDesc: 'Everything you need for an unforgettable football and learning experience',
      features: [
        { category: 'Age Group', title: 'Boys 11-17 Years', description: 'Grouped by age and ability level for optimal development' },
        { category: 'Training Intensity', title: 'High Performance', description: '4.5/5 intensity rating for elite development' },
        { category: 'Coaching Staff', title: 'UEFA Licensed Coaches', description: 'From top European academies including La Liga and Bundesliga' },
        { category: 'Accommodation', title: 'Oakham School', description: 'Full board in historic private school setting' },
        { category: 'Language', title: '24/7 English Immersion', description: 'With 4.5 hours of structured classes daily' },
        { category: 'Evaluation', title: 'Performance Reports', description: 'Comprehensive assessment of skills and progress' }
      ],
      trainingTitle: 'Elite Training Methodology',
      trainingDesc: 'Our training program is designed to challenge and develop players at the highest level',
      technicalSkills: 'Technical Skills',
      technicalSkillsDesc: 'Ball control, passing precision, and shooting techniques',
      tacticalAwareness: 'Tactical Awareness',
      tacticalAwarenessDesc: 'Game reading, positioning, and decision making',
      physicalConditioning: 'Physical Conditioning',
      physicalConditioningDesc: 'Speed, agility, strength, and endurance',
      mentalDevelopment: 'Mental Development',
      mentalDevelopmentDesc: 'Focus, confidence, and competitive mindset',
      coachingExcellence: 'Coaching Excellence',
      coachingExcellenceDesc: 'Our coaches bring experience from Europe\'s top football academies',
      academiesTitle: 'Partner Academies',
      academiesDesc: 'Our coaches have trained at these world-renowned academies',
      scheduleTitle: 'Daily Schedule',
      scheduleDesc: 'A typical day at the High Performance Clinic',
      schedule: [
        { time: '7:30', activity: 'Wake Up', detail: 'Morning preparation' },
        { time: '8:00', activity: 'Breakfast', location: 'Dining Hall' },
        { time: '9:00', activity: 'Morning Training', detail: 'Technical & tactical work', location: 'Training Pitches' },
        { time: '11:30', activity: 'English Classes', detail: 'Level-based groups', location: 'Classrooms' },
        { time: '13:30', activity: 'Lunch', location: 'Dining Hall' },
        { time: '15:00', activity: 'Afternoon Training', detail: 'Match preparation & games', location: 'Training Pitches' },
        { time: '17:30', activity: 'Free Time', detail: 'Pool, games, rest' },
        { time: '19:00', activity: 'Dinner', location: 'Dining Hall' },
        { time: '20:00', activity: 'Evening Activities', detail: 'Films, team bonding' },
        { time: '22:00', activity: 'Lights Out' }
      ],
      pricingDates: 'Pricing & Dates',
      pricingDatesDesc: 'Choose the perfect duration for your High Performance Clinic experience',
      week: 'Week',
      weeks2: 'Weeks',
      fullBoardIncluded: 'Full board included',
      mostPopular: 'MOST POPULAR',
      dailyTrainingSessions: '2 daily training sessions',
      englishLessons: 'English lessons (4.5hrs/day)',
      allActivitiesIncluded: 'All activities included',
      stadiumExcursion: 'Stadium excursion',
      extendedEvaluationReport: 'Extended evaluation report',
      comprehensiveEvaluation: 'Comprehensive evaluation',
      certificateCompletion: 'Certificate of completion',
      startDates2026: '2026 Start Dates',
      available: 'Available',
      experienceClinic: 'Experience the Clinic',
      experienceClinicDesc: 'See our players training with top European academy coaches'
    },
    languageSection: {
      title: 'Complete English Immersion',
      subtitle: 'Learn English naturally through football and daily activities',
      hoursDaily: '4.5 Hours Daily',
      description: 'English is the central focus of the experience. All activities, both inside and outside the classroom, are carefully designed to provide complete linguistic immersion in a dynamic and motivating environment.',
      feature1: 'Qualified TEFL-certified teachers',
      feature2: '100% communicative approach',
      feature3: 'Training conducted entirely in English',
      feature4: 'Real-life situations and practical activities',
      interactiveLearning: 'Interactive Learning',
      interactiveLearningDesc: 'Role-playing and teamwork activities',
      multicultural: 'Multicultural',
      multiculturalDesc: 'Students from around the world',
      provenResults: 'Proven Results',
      provenResultsDesc: 'Tangible improvement in weeks',
      certificate: 'Certificate',
      certificateDesc: 'Completion certificate included',
      howYoullLearn: 'How You\'ll Learn',
      inClassroom: 'In the Classroom',
      inClassroomDesc: 'Structured lessons with qualified teachers focusing on communication skills',
      onField: 'On the Field',
      onFieldDesc: 'Training sessions conducted entirely in English with technical vocabulary',
      dailyLife: 'Daily Life',
      dailyLifeDesc: 'Meals, activities, and free time all conducted in English for natural learning'
    },
    training: {
      trainingProgram: 'Training Program',
      eliteLevelTraining: 'Elite-Level Football Training',
      intensity: 'Intensity',
      studentsPerGroup: 'Students/Group',
      dailySessions: 'Daily Sessions',
      whatsIncluded: 'What\'s Included',
      features: [
        '2 training sessions per day in English',
        'Individual and group tactical exercises',
        'Specific goalkeeper training',
        'Match analysis and video review',
        'Friendly matches and tournaments',
        'Evaluation report at end of camp'
      ]
    },
    astonVilla: {
      heroTitle: 'Aston Villa Foundation Program',
      heroTagline: 'Official Aston Villa Foundation Coaching Experience',
      ages: 'Ages',
      hoursTrainingWeek: '20 Hours Training/Week',
      englishClassesIncluded: 'English Classes Included',
      viewPrices: 'View Prices',
      signUpNow: 'Sign Up Now',
      programOverview: 'Program Overview',
      description: 'The Aston Villa Foundation program offers an exclusive experience combining official Premier League coaching with English language immersion. Train with certified Aston Villa Foundation coaches while developing both football and language skills in a world-class environment.',
      duration: 'Duration',
      training: 'Training',
      english: 'English',
      hrsWeek: 'hrs/week',
      programHighlights: 'Program Highlights',
      programHighlightsDesc: 'Experience Premier League standard training combined with comprehensive English education',
      features: [
        { title: 'Official Foundation Coaches', description: 'Led by official coaches from the Aston Villa Foundation' },
        { title: '20 Hours Training/Week', description: 'Up to 20 hours of intensive training divided into two daily sessions' },
        { title: 'English Classes', description: 'Up to 7.5 hours of English classes per week with level-based groups' },
        { title: 'Sports Workshops', description: '8 hours of professional workshops on strategy, nutrition, and injury prevention' }
      ],
      eliteFootballTraining: 'Elite Football Training',
      eliteFootballTrainingDesc: 'hours per week of intensive training led by official Aston Villa Foundation coaches, focusing on individual technique, team tactics, and competitive intensity.',
      hoursTrainingWeekLabel: 'Hours Training/Week',
      hoursWorkshopsWeek: 'Hours Workshops/Week',
      professionalWorkshopsInclude: 'Professional Workshops Include:',
      workshopTopics: ['Game strategy and tactics', 'Sports nutrition', 'Injury prevention', 'Mental preparation', 'Career development'],
      ledBy: 'Led by',
      workshopLedBy: 'Aston Villa Foundation certified professionals',
      englishLanguageImmersion: 'English Language Immersion',
      dynamicEnglishClasses: 'Dynamic English Classes',
      hoursPerWeek: 'Hours per week:',
      groupSize: 'Group size:',
      levels: 'Levels:',
      differentGroupsBasedOnTest: 'different groups based on initial test',
      certificate: 'Certificate:',
      diplomaUponCompletion: 'Diploma upon completion',
      englishObjective: 'Our English classes use sports as a vehicle for natural language acquisition, making learning engaging and relevant to students\' interests.',
      englishMethodology: 'Dynamic, football-focused English classes designed to engage young athletes while developing real communication skills.',
      grammarConversation: 'Grammar, conversation, and technical vocabulary within a football context',
      smallGroupsTailored: 'Small groups tailored to each student\'s level',
      initialLevelTest: 'Initial level test to ensure proper placement',
      focusOnOvercomingFears: 'Focus on overcoming communication fears and building confidence',
      dailySchedule: 'Daily Schedule',
      dailyScheduleDesc: 'A typical day at the Aston Villa Foundation Program',
      schedule: [
        { time: '7:30', activity: 'Wake Up', detail: 'Morning preparation' },
        { time: '8:00', activity: 'Breakfast', location: 'Dining Hall' },
        { time: '9:00', activity: 'English Classes', detail: 'Level-based groups', location: 'Classrooms' },
        { time: '11:00', activity: 'Morning Training', detail: 'Technical and tactical work', location: 'Training Grounds' },
        { time: '13:30', activity: 'Lunch', location: 'Dining Hall' },
        { time: '15:00', activity: 'Afternoon Training', detail: 'Match preparation and games', location: 'Training Grounds' },
        { time: '17:30', activity: 'Free Time', detail: 'Pool, games room, or rest' },
        { time: '19:00', activity: 'Dinner', location: 'Dining Hall' },
        { time: '20:00', activity: 'Evening Activities', detail: 'Football films, team bonding' },
        { time: '22:00', activity: 'Lights Out' }
      ],
      whatsIncluded: 'What\'s Included',
      whatsIncludedDesc: 'Everything you need for an unforgettable experience',
      included: [
        'Full board accommodation at Oakham School',
        'Official Aston Villa training kit',
        'Up to 20 hours of football training per week',
        'Up to 7.5 hours of English classes',
        '8 hours of professional sports workshops',
        'Stadium excursion to Premier League ground',
        'Complete evaluation report and diploma',
        'All activities and excursions',
        'Sports facilities access',
        '24/7 supervision and medical assistance'
      ],
      pricingDates: 'Pricing & Dates',
      pricingDatesDesc: 'Choose your Aston Villa Foundation program duration',
      week: 'Week',
      weeks: 'Weeks',
      fullBoardTrainingKit: 'Full board + training kit included',
      upTo20HoursTraining: 'Up to 20 hours training per week',
      englishClasses: 'English classes (7.5hrs/week)',
      officialTrainingKit: 'Official Aston Villa training kit',
      stadiumExcursion: 'Stadium excursion',
      sportsWorkshops: 'Sports workshops (8hrs/week)',
      competitiveMatches: 'Competitive matches',
      completeEvaluationReport: 'Complete evaluation report',
      mostPopular: 'MOST POPULAR',
      startDates2026: '2026 Start Dates',
      registrationFee: 'Registration fee:',
      initialDeposit: 'Initial deposit:',
      freeCancellationUntil: '(free cancellation insurance included — book before May 1st)',
      experienceProgram: 'Experience the Program',
      experienceProgramDesc: 'See our players in action at the Aston Villa Foundation training sessions'
    },
    englishImmersion: {
      badge: '24/7 Complete Immersion',
      heroTitle: 'Full English Immersion Experience',
      heroSubtitle: 'Every moment at camp is an opportunity to learn English naturally - from classroom to pitch, from meals to activities',
      countries: '30+ Countries',
      englishEnvironment: '100% English Environment',
      teflCertified: 'TEFL Certified Teachers',
      viewPrograms: 'View Programs',
      signUpNow: 'Sign Up Now',
      moreThanClasses: 'More Than Just English Classes',
      moreThanClassesDesc1: 'In our summer camp, English is the central focus of the entire experience. All activities, both inside and outside the classroom, are carefully designed to provide a complete linguistic immersion in a dynamic and motivating environment.',
      moreThanClassesDesc2: 'This is not just about optional English classes - it\'s a 24/7 English immersion program where every moment becomes a natural learning opportunity.',
      learningQuote: '"Learning occurs progressively, naturally, and almost without realizing it, while enjoying an unforgettable summer."',
      immersionTitle: '24/7 English Immersion',
      immersionDesc: 'Every aspect of camp life is designed to immerse you in English from morning to night',
      classroomTeaching: '8-12 Hours Classroom Teaching',
      classroomTeachingDesc: 'Professional English lessons per week with TEFL certified teachers',
      footballWorkshops: 'Football Workshops in English',
      footballWorkshopsDesc: 'All football-related workshops conducted entirely in English',
      clubPresentations: 'Club Presentations in English',
      clubPresentationsDesc: 'Presentations from professional clubs and academies in English',
      videoAnalysis: 'Video Analysis in English',
      videoAnalysisDesc: 'Training sessions and match analysis conducted in English',
      trainingSessions: 'Training Sessions in English',
      trainingSessionsDesc: 'All coaching and training delivered in English',
      internationalEnvironment: 'International Environment',
      internationalEnvironmentDesc: 'Participants from 30+ countries creating natural English communication',
      englishMonitors: '24/7 English Speaking Monitors',
      englishMonitorsDesc: 'Staff and monitors always communicate in English',
      freeTimeActivities: 'Free Time Activities in English',
      freeTimeActivitiesDesc: 'All leisure and fun activities conducted in English',
      professionalClasses: 'Professional English Classes',
      professionalClassesDesc: 'TEFL certified teachers delivering 4.5 hours of professional instruction daily',
      classSchedule: 'Class Schedule',
      hoursPerDay: '4.5 hours per day (Monday to Friday)',
      teflCertifiedTeachers: 'TEFL certified teachers with professional qualifications',
      footballFocusedContext: 'Football-focused context combining learning and fun',
      communicativeApproach: '100% communicative approach - natural from day one',
      teachingMethodology: 'Teaching Methodology',
      teachingMethodologyDesc1: 'Our approach is 100% communicative, prioritizing verbal interaction through practical activities and real-life situations.',
      teachingMethodologyDesc2: 'Adapted to young people of different ages, levels, and nationalities, ensuring everyone progresses at their own pace.',
      outsideClassroom: 'Outside the Classroom Activities',
      outsideClassroomDesc: 'A variety of activities reinforce what has been learned during lessons:',
      rolePlayingGames: 'Role-playing games and simulations of daily life',
      teamworkExercises: 'Teamwork and problem-solving exercises',
      funCreativeActivities: 'Fun and creative activities',
      practicalActivities: 'Practical activities and real-life situations',
      sportsContinuousLearning: 'Sports as Continuous Learning',
      duringTraining: 'During Training',
      duringTrainingDesc: 'Coaches communicate in English, using technical and everyday vocabulary that reinforces what students have learned in the classroom.',
      dailyCampLife: 'In Daily Camp Life',
      dailyCampLifeDesc: 'Meals, workshops, activities, and free time - everything is conducted in English, integrating the language into every moment of the day.',
      multiculturalSpace: 'Multicultural Space',
      multiculturalSpaceDesc1: 'The camp is a multicultural space, where young people from different countries and cultures live together.',
      multiculturalSpaceDesc2: 'With participants from 30+ countries, this diversity enriches the experience and reinforces the use of English as a common language, promoting learning in an authentic, inclusive, and motivating context.',
      naturalCommunication: 'Natural English Communication',
      naturalCommunicationDesc: 'When players from Italy, Spain, Germany, Netherlands, and beyond come together, English becomes the natural bridge - forcing and encouraging daily conversation in an authentic way.',
      ourGoal: 'Our Goal for Each Participant',
      ourGoalDesc: 'By the end of camp, you will have achieved tangible progress in your English journey',
      improveEnglish: 'Improve English level in tangible ways',
      gainConfidence: 'Gain confidence in communication',
      developIntercultural: 'Develop intercultural skills',
      bePartOfCommunity: 'Be part of an international community',
      completeImmersion: 'Complete Immersion Experience',
      completeImmersionDesc: 'At the end of the camp, students will have had a true language immersion experience, made friends from all over the world, and made significant progress in their English proficiency...',
      safeEnvironment: 'All in a safe, sporting, and stimulating environment.',
      readyToExperience: 'Ready to Experience Full English Immersion?',
      readyToExperienceDesc: 'Join us for an unforgettable summer of football and language learning',
      viewProgramsPrices: 'View Programs & Prices'
    },
    technology: {
      badge: 'Advanced Performance Technology',
      heroTitle: 'Technology & Analysis',
      heroSubtitle: 'We use cutting-edge technology to enhance player development, provide detailed feedback, and measure improvement throughout the camp experience',
      veoCamera: 'Veo Camera',
      veoCameraTagline: 'Professional Video Recording & Live Streaming',
      videoAnalysis: 'Video Analysis',
      videoAnalysisTagline: 'Interactive Performance Review Sessions',
      draftApp: 'The Draft App',
      draftAppTagline: 'AI-Powered Player Assessment',
      evaluationReports: 'Evaluation Reports',
      evaluationReportsTagline: 'Comprehensive Personalized Reports',
      veoCameraSystem: 'Veo Camera System',
      veoCameraSystemDesc: 'All training sessions and matches are recorded with professional Veo cameras, providing HD quality footage for live streaming and detailed post-session analysis.',
      veoFeature1: 'Records all training sessions and matches in HD quality',
      veoFeature2: 'Live streaming capability for families to watch from anywhere',
      veoFeature3: 'Automatic player tracking and tactical camera angles',
      veoFeature4: 'Cloud storage for easy access to all footage',
      veoFeature5: 'Used for post-match and post-training analysis',
      liveStreamingFamilies: 'Live Streaming for Families',
      liveStreamingFamiliesDesc: 'Parents and family members can watch training sessions and matches live from anywhere in the world, staying connected to their player\'s experience.',
      professionalRecording: 'Professional Recording',
      professionalRecordingDesc: 'Every moment captured in broadcast quality with automatic player tracking and tactical angles.',
      quality: 'Quality',
      streaming: 'Streaming',
      storage: 'Storage',
      access: 'Access',
      professionalVideoAnalysis: 'Professional Video Analysis',
      professionalVideoAnalysisDesc: 'Several times per week, a professional football analyst reviews footage with players and coaches in interactive sessions where players are actively involved.',
      analysisFeature1: 'Several professional analysis sessions per week',
      analysisFeature2: 'Interactive sessions with active player participation',
      analysisFeature3: 'Pre-camp video evaluation with family call included',
      analysisFeature4: 'Focus on individual areas for improvement',
      analysisFeature5: 'Tactical, technical, and positional analysis',
      analysisFeature6: 'Coach and analyst feedback in real-time',
      personalizedFocus: 'Personalized Focus',
      personalizedFocusDesc: 'Each player receives individual attention, with analysis tailored to their specific position, playing style, and areas for improvement.',
      interactiveAnalysis: 'Interactive Analysis Sessions',
      preCampEvaluation: 'Pre-Camp Evaluation',
      preCampEvaluationDesc: 'Send in a video before camp starts. Receive a personalized call with family present to discuss areas of focus and improvement goals.',
      duringCampSessions: 'During Camp Sessions',
      duringCampSessionsDesc: 'Multiple weekly sessions with professional analysts reviewing your footage, explaining improvements, and analyzing different game situations.',
      activeParticipation: 'Active Participation',
      activeParticipationDesc: 'Players are actively involved in sessions, discussing tactics, asking questions, and understanding their performance in detail.',
      comprehensiveReports: 'Comprehensive Evaluation Reports',
      comprehensiveReportsDesc: 'At the end of camp, each player receives a full personalized evaluation report',
      reportIncludes: 'Your Report Includes:',
      technicalSkills: 'Technical Skills Assessment',
      technicalSkillsDesc: 'Detailed evaluation of ball control, passing, shooting, and dribbling',
      tacticalUnderstanding: 'Tactical Understanding',
      tacticalUnderstandingDesc: 'Positioning, decision-making, and game intelligence analysis',
      physicalPerformance: 'Physical Performance',
      physicalPerformanceDesc: 'Speed, stamina, strength, and athletic capabilities',
      mentalSocialSkills: 'Mental & Social Skills',
      mentalSocialSkillsDesc: 'Leadership, teamwork, attitude, and coachability',
      recommendations: 'Recommendations',
      recommendationsDesc: 'Specific areas to focus on and training suggestions for continued development',
      sampleReport: 'Sample Report',
      multiPageAnalysis: 'Comprehensive multi-page analysis',
      reportDelivered: 'Professional evaluation report delivered digitally',
      viewFullReport: 'View Full Report',
      downloadSampleReport: 'Download Sample Report (PDF)',
      aiPoweredAssessment: 'The Draft App: AI-Powered Assessment',
      aiPoweredAssessmentDesc: 'We use cutting-edge AI technology to evaluate players on different physical and technical abilities before, during, and after camp',
      howItWorks: 'How It Works',
      downloadApp: 'Download the App',
      downloadAppDesc: 'Available for iOS and Android devices',
      setupTestScene: 'Set Up Test Scene',
      setupTestSceneDesc: 'Use football cones for dribbling, a goal for power shooting, and other simple setups',
      completeTests: 'Complete Tests',
      completeTestsDesc: 'AI models evaluate your performance using computer vision',
      getResults: 'Get Results',
      getResultsDesc: 'Receive age-appropriate benchmarking and track improvement over time',
      whatWeMeasure: 'What We Measure',
      appPreview: 'App Preview',
      draftFeature1: 'AI-powered evaluation of physical abilities',
      draftFeature2: 'Technical skills assessment using computer vision',
      draftFeature3: 'Age-appropriate performance benchmarking',
      draftFeature4: 'Tests include dribbling, power shooting, and more',
      draftFeature5: 'Easy setup with just football cones and a goal',
      draftFeature6: 'Track progress before, during, and after camp',
      trackProgress: 'Track Your Progress',
      trackProgressDesc: 'Test yourself before camp, during camp, and after camp to see measurable improvements in your abilities. The AI takes into account your age and provides personalized benchmarks.',
      objectiveAssessment: 'Objective, Data-Driven Assessment',
      objectiveAssessmentDesc: 'AI technology removes subjectivity and provides accurate, consistent measurements of your abilities',
      experienceTechnology: 'Experience Technology-Enhanced Training',
      experienceTechnologyDesc: 'Join a camp where cutting-edge technology meets professional coaching for maximum player development',
      viewProgramsPrices: 'View Programs & Prices',
      signUpNow: 'Sign Up Now'
    },
    aboutOakham: {
      heroTitle: 'Oakham School',
      heroDesc: 'A prestigious British boarding school providing world-class facilities for our football camps',
      perfectLocation: 'Perfect Location',
      locationTown: 'Oakham',
      locationRegion: 'Rutland, England',
      locationFromLondon: '2 hours north of London',
      nearestAirports: 'Nearest Airports',
      airports: [
        'East Midlands Airport (45 min)',
        'Birmingham Airport (1 hour)'
      ],
      accommodation: 'Accommodation',
      rooms: 'Rooms',
      roomTypes: 'Shared rooms (double or triple), limited single rooms available',
      bathrooms: 'Bathrooms:',
      bathroomsDesc: 'Shared facilities on each floor',
      amenities: 'Amenities',
      amenitiesList: [
        '24/7 supervision and security',
        'Daily room cleaning service',
        'Linen and towel changes',
        'Free WiFi throughout',
        'Common areas with TV and games',
        'Laundry service available'
      ],
      dining: 'Dining',
      mealsNutrition: 'Meals & Nutrition',
      meals: 'Meals:',
      mealsDesc: 'Three nutritious meals per day plus snacks',
      cuisine: 'Cuisine:',
      cuisineDesc: 'International menu with British classics',
      dietary: 'Dietary:',
      dietaryDesc: 'All dietary requirements accommodated',
      features: 'Features',
      diningFeatures: [
        'Professional catering team',
        'Fresh, locally-sourced ingredients',
        'Balanced athlete nutrition',
        'Vegetarian and vegan options',
        'Allergen-free meals available',
        'Dining hall with stunning architecture'
      ],
      worldClassFacilities: 'World-Class Facilities',
      sportsFacilities: 'Sports Facilities',
      sportsFeatures: [
        'Multiple natural grass pitches',
        'Full-size artificial turf pitch',
        'Olympic-size swimming pool',
        'Fully equipped gymnasium',
        'Indoor sports hall',
        'Changing rooms and showers'
      ],
      academicFacilities: 'Academic Facilities',
      academicFeatures: [
        'Modern classrooms for English lessons',
        'Language labs',
        'Library and study areas',
        'Video analysis room'
      ],
      recreational: 'Recreational',
      recreationalFeatures: [
        'Games room with pool and ping-pong',
        'TV lounges',
        'PlayStation gaming areas',
        'Outdoor recreation spaces'
      ],
      safetySecurity: 'Safety & Security',
      safetyDesc: 'Your child\'s safety is our top priority. Oakham provides a secure, supervised environment with 24/7 staff presence, CCTV monitoring, and comprehensive safeguarding procedures.',
      staffSupervision: 'Staff Supervision',
      townEnvironment: 'Town Environment',
      safe: 'Safe',
      medicalCare: 'Medical Care',
      onSite: 'On-Site'
    },
    prices: {
      heroTitle: 'Pricing & Dates',
      heroSubtitle: 'Flexible durations to fit your schedule. All prices include accommodation, meals, training, and English lessons.',
      highPerformanceClinic: 'High Performance Clinic',
      chooseDuration: 'Choose the perfect duration for your summer camp experience',
      week: 'Week',
      weeks: 'Weeks',
      oneWeek: '1 Week',
      twoWeeks: '2 Weeks',
      threeWeeks: '3 Weeks',
      fourWeeks: '4 Weeks',
      fullBoardIncluded: 'Full board included',
      mostPopular: 'MOST POPULAR',
      signUpNow: 'Sign Up Now',
      startDates2026: '2026 Start Dates',
      available: 'Available',
      soldOut: 'Sold Out',
      spotsLeft: 'spots left',
      onlyXSpotsLeft: 'Only {x} spots left!',
      limitedAvailability: 'Limited Availability',
      clinicSoldOut: 'Clinic — Sold Out',
      astonVillaAvailable: 'Aston Villa — {x} spots',
      astonVillaProgram: 'Aston Villa Foundation Program',
      astonVillaDesc: 'Official Aston Villa Foundation training experience',
      fullBoardTrainingKit: 'Full board + training kit included',
      registrationInfo: 'Registration Information',
      registrationFee: 'Registration Fee',
      initialDeposit: 'Initial Deposit',
      freeCancellation: 'Free cancellation insurance included (book before May 1st)',
      paymentOptions: 'Payment Options',
      gbpEurUsd: 'GBP, EUR, or USD',
      paymentsAccepted: 'Payments accepted in GBP, EUR, or USD at current exchange rates.',
      groupDiscounts: 'Group discounts available for family members or friends. Contact us for details.',
      whatsIncluded: 'What\'s Included in All Prices',
      accommodationTitle: 'Accommodation',
      fullBoard: 'Full board (3 meals + snacks)',
      sharedAccommodation: 'Shared accommodation',
      linenTowels: 'Linen & towels',
      supervision: '24/7 supervision',
      trainingEducation: 'Training & Education',
      dailyTrainingSessions: '2 training sessions daily',
      englishLessons: 'English lessons (4.5 hrs/day)',
      uefaCoaches: 'UEFA licensed coaches',
      evaluationReport: 'Evaluation report',
      activitiesExtras: 'Activities & Extras',
      stadiumExcursion: 'Stadium excursion',
      facilitiesAccess: 'All facilities access',
      eveningActivities: 'Evening activities',
      freeWifi: 'Free WiFi',
      readyToSecure: 'Ready to secure your place?',
      // Clinic features
      clinicFeatures: {
        '20hours': '20+ hours football training',
        '40hours': '40+ hours football training',
        '60hours': '60+ hours football training',
        '80hours': '80+ hours football training',
        'english45': '4.5 hours English daily',
        'fullBoard': 'Full board accommodation',
        'stadiumExcursion': 'Stadium excursion',
        'stadiumExcursions2': '2 stadium excursions',
        'stadiumExcursions3': '3 stadium excursions',
        'stadiumExcursions4': '4 stadium excursions',
        'tournament': 'End of camp tournament',
        'analysisReport': 'Performance analysis report',
        'completeAnalysis': 'Complete performance analysis',
        'certificate': 'Certificate of completion'
      },
      // Aston Villa features
      villaFeatures: {
        'officialCoaching': 'Official Aston Villa coaching',
        '20hours': '20+ hours training',
        '40hours': '40+ hours training',
        'villaParkVisit': 'Villa Park stadium visit',
        'fullKit': 'Full Aston Villa kit',
        'evaluation': 'Performance evaluation',
        'certificate': 'Certificate of completion'
      }
    },
    contact: {
      heroTitle: 'Get in Touch',
      heroSubtitle: 'Have questions about our programs? We\'re here to help you find the perfect football camp experience.',
      sendMessage: 'Send Us a Message',
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      interestedIn: 'Interested In',
      selectProgram: 'Select a program',
      highPerformanceClinic: 'High Performance Clinic',
      astonVillaProgram: 'Aston Villa Program',
      bothPrograms: 'Both Programs',
      generalInquiry: 'General Inquiry',
      message: 'Message',
      messagePlaceholder: 'Tell us about your inquiry, player\'s age, preferred dates, or any questions you have...',
      sendMessageBtn: 'Send Message',
      sending: 'Sending...',
      successMessage: 'Thank you for your message! We will get back to you soon.',
      errorMessage: 'There was an error sending your message. Please try again.',
      emailUs: 'Email Us',
      emailResponse: 'We typically respond within 24 hours',
      callUs: 'Call Us',
      callHours: 'Monday - Friday: 9am - 6pm GMT',
      visitUs: 'Visit Us',
      quickLinks: 'Quick Links',
      viewPricesDates: 'View Prices & Dates',
      clinicProgramDetails: 'Clinic Program Details',
      aboutOakhamSchool: 'About Oakham School',
      signUpNow: 'Sign Up Now'
    },
    signUp: {
      heroTitle: 'Sign Up Now',
      heroSubtitle: 'Start your journey to football excellence. Complete the form below to register for summer 2026.',
      parentGuardianInfo: 'Parent/Guardian Information',
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      playerInfo: 'Player Information',
      playerFullName: 'Player\'s Full Name',
      age: 'Age',
      gender: 'Gender',
      selectGender: 'Select gender',
      male: 'Male',
      female: 'Female',
      programSelection: 'Program Selection',
      program: 'Program',
      selectProgram: 'Select a program',
      highPerformanceClinic: 'High Performance Clinic',
      astonVillaProgram: 'Aston Villa Program',
      duration: 'Duration',
      selectDuration: 'Select duration',
      selectProgramFirst: 'Select a program first',
      startDate: 'Start Date',
      selectStartDate: 'Select start date',
      additionalInfo: 'Additional Information',
      medicalConditions: 'Medical Conditions or Allergies',
      medicalPlaceholder: 'Please list any medical conditions, allergies, or medications',
      dietaryRequirements: 'Dietary Requirements',
      dietaryPlaceholder: 'Vegetarian, vegan, halal, allergies, etc.',
      emergencyContact: 'Emergency Contact (if different from parent)',
      emergencyPlaceholder: 'Name and phone number',
      whatHappensNext: 'What Happens Next?',
      step1: 'You\'ll receive a confirmation email within 24 hours',
      step2: 'We\'ll send you registration documents and payment details',
      step3: 'Complete payment to secure your place',
      step4: 'Receive welcome pack with camp details 4 weeks before start',
      completeRegistration: 'Complete Registration',
      submitting: 'Submitting...',
      successMessage: 'Thank you for registering! We will contact you shortly with confirmation details.',
      errorMessage: 'There was an error processing your registration. Please try again.',
      termsAgreement: 'By submitting this form, you agree to our terms and conditions and privacy policy.'
    },
    legal: {
      termsTitle: 'Terms & Conditions',
      privacyTitle: 'Privacy Policy',
      cookieTitle: 'Cookie Policy',
      lastUpdated: 'Last Updated:',
      introduction: '1. Introduction',
      termsPlaceholder: 'Please copy the Terms & Conditions content from:',
      privacyPlaceholder: 'Please copy the Privacy Policy content from:',
      cookiePlaceholder: 'Please copy the Cookie Policy content from:',
      termsIncludes: 'This page should include all terms and conditions covering:',
      privacyIncludes: 'This page should include all privacy policy information covering:',
      cookieIncludes: 'This page should include all cookie policy information covering:',
      servicesOffered: 'Services offered',
      bookingPayment: 'Booking and payment terms',
      cancellationPolicies: 'Cancellation policies',
      campRules: 'Camp rules and regulations',
      liabilityLimitations: 'Liability limitations',
      userResponsibilities: 'User responsibilities',
      personalDataCollected: 'What personal data is collected',
      dataUsedStored: 'How data is used and stored',
      dataRetention: 'Data retention periods',
      userRights: 'User rights (access, edit, delete)',
      dataSecurity: 'Data security measures',
      thirdPartySharing: 'Third-party data sharing',
      contactInfo: 'Contact information for data inquiries',
      whatCookiesAre: 'What cookies are and how they work',
      typesOfCookies: 'Types of cookies used on the website',
      purposeOfCookies: 'Purpose of each cookie type',
      manageCookies: 'How to manage cookie preferences',
      thirdPartyCookies: 'Third-party cookies',
      cookieConsent: 'Cookie consent mechanisms',
      campSpecificPolicies: '2. Camp-Specific Policies',
      campSpecificDesc: 'Include details about deposits, payment schedules, refund policies, and any program-specific terms.',
      codeOfConduct: '3. Code of Conduct',
      codeOfConductDesc: 'Include camp rules regarding behavior, safety, prohibited items, and consequences for violations.',
      dataCollection: '2. Data Collection',
      dataCollectionDesc: 'Include details about what types of personal information are collected (names, dates of birth, contact information, medical information, etc.).',
      yourRights: '3. Your Rights',
      yourRightsDesc: 'Include information about GDPR rights and how users can exercise them.',
      typesOfCookiesSection: '2. Types of Cookies',
      typesOfCookiesDesc: 'Include details about essential cookies, performance cookies, functional cookies, and targeting/advertising cookies.',
      managingCookies: '3. Managing Cookies',
      managingCookiesDesc: 'Include information about how users can control and delete cookies through their browser settings.',
      adminNoteTerms: 'Note to Administrator: Please replace this placeholder content with the actual Terms & Conditions. The content should be copied in its entirety to ensure legal compliance and accuracy.',
      adminNotePrivacy: 'Note to Administrator: Please replace this placeholder content with the actual Privacy Policy. The content should be copied in its entirety to ensure legal compliance with GDPR and other privacy regulations.',
      adminNoteCookie: 'Note to Administrator: Please replace this placeholder content with the actual Cookie Policy. The content should be copied in its entirety to ensure legal compliance with EU cookie laws and regulations.'
    }
  },
  es: {
    nav: {
      clinic: 'Clínica',
      astonVilla: 'Aston Villa',
      englishImmersion: 'Inmersión Total en Inglés',
      technology: 'Tecnología y Análisis',
      aboutOakham: 'Sobre Oakham',
      prices: 'Precios',
      contact: 'Contacto',
      signUp: 'Inscríbete Ahora'
    },
    hero: {
      badge: 'Más de 20 Años de Excelencia',
      title: 'Campamentos de Fútbol de Élite en Oakham, Inglaterra',
      subtitle: 'Dos programas excepcionales. Una ubicación de clase mundial. Más de 20 años de excelencia.',
      exploreProgramsBtn: 'Explorar Programas',
      viewPricesBtn: 'Ver Precios'
    },
    home: {
      tech: {
        badge: 'Tecnología de Vanguardia',
        title: 'Entrena Más Inteligente con Tecnología',
        subtitle: 'Utilizamos la última tecnología para rastrear, analizar y acelerar tu desarrollo futbolístico',
        veoTitle: 'Sistema de Cámara Veo',
        veoDesc: 'Grabación profesional de partidos con análisis impulsado por IA y destacados automáticos',
        draftTitle: 'The Draft App',
        draftDesc: 'Evaluación de habilidades físicas y técnicas con IA y comparativas apropiadas para la edad',
        reportsTitle: 'Informes de Evaluación',
        reportsDesc: 'Análisis completo de múltiples páginas con recomendaciones personalizadas para el desarrollo continuo',
        cta: 'Explorar Nuestra Tecnología'
      }
    },
    programs: {
      title: 'Elige Tu Programa',
      subtitle: 'Dos programas de fútbol de clase mundial en el corazón de Inglaterra. Ambos ofrecen entrenamiento de élite, inmersión en inglés y experiencias inolvidables.',
      from: 'Desde',
      viewDetails: 'Ver Detalles del Programa',
      learnMore: 'Más Información',
      comingSoon: 'Próximamente',
      // Program cards data
      clinic: {
        name: 'Clínica de Alto Rendimiento',
        tagline: 'Entrenamiento de élite con entrenadores de las mejores academias europeas',
        highlights: [
          'Entrenadores con licencia UEFA de las mejores academias europeas',
          'Inmersión en inglés (4.5 horas diarias)',
          'Entrenamiento de alta intensidad (4.5/5)',
          'Edades 11-17, solo chicos',
          'Enfoque en desarrollo de habilidades individuales'
        ]
      },
      astonVilla: {
        name: 'Programa Fundación Aston Villa',
        tagline: 'Entrenamiento oficial de la Fundación Aston Villa en Inglaterra',
        highlights: [
          'Entrenadores oficiales de la Fundación Aston Villa',
          '20 horas de entrenamiento + 8 horas de talleres por semana',
          'Clases de inglés (7.5 horas/semana)',
          'Edades 10-17, todos los niveles bienvenidos',
          'Excursión a estadio de la Premier League'
        ]
      }
    },
    whyOakham: {
      title: '¿Por Qué Entrenar en Oakham?',
      subtitle: 'Más de 20 años de excelencia en el desarrollo de jóvenes futbolistas',
      reasons: [
        {
          title: 'Más de 20 Años de Experiencia',
          description: 'Dos décadas desarrollando con éxito jóvenes futbolistas de todo el mundo'
        },
        {
          title: 'Ubicación Perfecta',
          description: 'Ciudad histórica en el corazón de Inglaterra, a 2 horas de Londres, ambiente seguro y acogedor'
        },
        {
          title: 'Comunidad Internacional',
          description: 'Recibimos jugadores de más de 30 países, creando una experiencia futbolística verdaderamente global'
        },
        {
          title: 'Instalaciones Premium',
          description: 'Campos de entrenamiento de clase mundial, alojamiento moderno y excelente comedor en Oakham School'
        }
      ]
    },
    activities: {
      title: 'Visitas a Estadios y Actividades',
      subtitle: 'Experimenta la cultura del fútbol inglés más allá del campo de entrenamiento',
      stadiumVisits: [
        {
          name: 'Estadio de Wembley',
          description: 'Visita el icónico estadio nacional de Inglaterra'
        },
        {
          name: 'Estadios de la Premier League',
          description: 'Experimenta el hogar de los mejores clubes ingleses'
        }
      ],
      freetimeTitle: 'Actividades de Tiempo Libre',
      freetimeActivities: [
        'Natación en piscina olímpica',
        'Sala de juegos con billar y ping-pong',
        'Sala de PlayStation y TV',
        'Acceso al gimnasio',
        'Presentaciones de fútbol nocturnas',
        'Actividades de trabajo en equipo'
      ]
    },
    testimonials: {
      title: 'Lo Que Dicen los Padres',
      subtitle: 'Escucha a las familias que han experimentado nuestros campamentos',
      items: [
        {
          name: 'Brenda',
          role: 'Madre de Jerónimo C. G., 15 años',
          country: 'España',
          text: 'Todo fue genial. Mi hijo estuvo muy feliz pasando tiempo allí y aprendiendo. Para resumirlo en una palabra: excelente. Creo que el campamento tiene todo lo que los niños necesitan para ser felices – aprender y disfrutar.',
          program: 'Clínica de Alto Rendimiento'
        },
        {
          name: 'Nouf',
          role: 'Padre de Zayed A., 13 años',
          country: 'Reino Unido',
          text: 'Una gran experiencia, respuesta rápida, ágil y profesional. Eduard el supervisor del campamento fue muy solidario y servicial.',
          program: 'Clínica de Alto Rendimiento'
        },
        {
          name: 'Dolores',
          role: 'Madre de Oriol N. P., 18 años',
          country: 'España',
          text: '¡La experiencia fue increíble! Definitivamente planeamos volver, y si fuera por nuestro hijo, ¡se quedaría todo el año! ¡10 de 10!',
          program: 'Clínica de Alto Rendimiento'
        },
        {
          name: 'Giuliana T.',
          role: 'Madre de Riccardo Z., 17 años',
          country: 'Italia',
          text: 'Fue una experiencia maravillosa para Riccardo, conoció a mucha gente y pudo hablar muchos idiomas con personas de diferentes países europeos.',
          program: 'Clínica de Alto Rendimiento'
        }
      ]
    },
    footer: {
      about: 'Campamentos de verano de fútbol e inglés de primer nivel en el corazón de Inglaterra.',
      contact: 'Contacto',
      legal: 'Legal',
      quickLinks: 'Enlaces Rápidos',
      terms: 'Términos y Condiciones',
      privacyPolicy: 'Política de Privacidad',
      cookiePolicy: 'Política de Cookies',
      copyright: '© 2026 Oakham Football Camps. Todos los derechos reservados.',
      ctaTitle: '¿Listo para Comenzar Tu Viaje Futbolístico?',
      ctaSubtitle: 'Únete a cientos de jóvenes jugadores que han transformado sus habilidades en la principal academia de fútbol de Inglaterra',
      getQuote: 'Solicitar Presupuesto',
      contactUs: 'Contáctanos'
    },
    clinic: {
      heroTitle: 'Clínica de Alto Rendimiento',
      heroSubtitle: 'Entrenamiento de fútbol de élite con entrenadores de las mejores academias europeas e inmersión total en inglés',
      viewPrices: 'Ver Precios',
      signUpNow: 'Inscríbete Ahora',
      programOverview: 'Descripción del Programa',
      programOverviewDesc: 'Entrenamiento de estilo profesional diseñado para jugadores avanzados/élite con técnica sólida e inteligencia de juego avanzada. Entrena con entrenadores con licencia UEFA de las mejores academias europeas.',
      ages: 'Edades',
      duration: 'Duración',
      intensity: 'Intensidad',
      english: 'Inglés',
      weeks: 'Semanas',
      hrsDay: 'hrs/día',
      programAtGlance: 'El Programa en Detalle',
      programAtGlanceDesc: 'Todo lo que necesitas para una experiencia inolvidable de fútbol y aprendizaje',
      features: [
        { category: 'Grupo de Edad', title: 'Chicos 11-17 Años', description: 'Agrupados por edad y nivel de habilidad para un desarrollo óptimo' },
        { category: 'Intensidad', title: 'Alto Rendimiento', description: 'Calificación de intensidad 4.5/5 para desarrollo de élite' },
        { category: 'Cuerpo Técnico', title: 'Entrenadores con Licencia UEFA', description: 'De las mejores academias europeas incluyendo La Liga y Bundesliga' },
        { category: 'Alojamiento', title: 'Oakham School', description: 'Pensión completa en histórico colegio privado' },
        { category: 'Idioma', title: 'Inmersión 24/7 en Inglés', description: 'Con 4,5 horas de clases estructuradas diarias' },
        { category: 'Evaluación', title: 'Informes de Rendimiento', description: 'Evaluación completa de habilidades y progreso' }
      ],
      trainingTitle: 'Metodología de Entrenamiento de Élite',
      trainingDesc: 'Nuestro programa de entrenamiento está diseñado para desafiar y desarrollar jugadores al más alto nivel',
      technicalSkills: 'Habilidades Técnicas',
      technicalSkillsDesc: 'Control del balón, precisión de pases y técnicas de tiro',
      tacticalAwareness: 'Conciencia Táctica',
      tacticalAwarenessDesc: 'Lectura del juego, posicionamiento y toma de decisiones',
      physicalConditioning: 'Preparación Física',
      physicalConditioningDesc: 'Velocidad, agilidad, fuerza y resistencia',
      mentalDevelopment: 'Desarrollo Mental',
      mentalDevelopmentDesc: 'Enfoque, confianza y mentalidad competitiva',
      coachingExcellence: 'Excelencia en Entrenamiento',
      coachingExcellenceDesc: 'Nuestros entrenadores aportan experiencia de las mejores academias de fútbol de Europa',
      academiesTitle: 'Academias Asociadas',
      academiesDesc: 'Nuestros entrenadores se han formado en estas academias de renombre mundial',
      scheduleTitle: 'Horario Diario',
      scheduleDesc: 'Un día típico en la Clínica de Alto Rendimiento',
      schedule: [
        { time: '7:30', activity: 'Despertar', detail: 'Preparación matutina' },
        { time: '8:00', activity: 'Desayuno', location: 'Comedor' },
        { time: '9:00', activity: 'Entrenamiento Matutino', detail: 'Trabajo técnico y táctico', location: 'Campos de Entrenamiento' },
        { time: '11:30', activity: 'Clases de Inglés', detail: 'Grupos por nivel', location: 'Aulas' },
        { time: '13:30', activity: 'Almuerzo', location: 'Comedor' },
        { time: '15:00', activity: 'Entrenamiento Vespertino', detail: 'Preparación de partidos y juegos', location: 'Campos de Entrenamiento' },
        { time: '17:30', activity: 'Tiempo Libre', detail: 'Piscina, juegos, descanso' },
        { time: '19:00', activity: 'Cena', location: 'Comedor' },
        { time: '20:00', activity: 'Actividades Nocturnas', detail: 'Películas, actividades de equipo' },
        { time: '22:00', activity: 'Apagar Luces' }
      ],
      pricingDates: 'Precios y Fechas',
      pricingDatesDesc: 'Elige la duración perfecta para tu experiencia en la Clínica de Alto Rendimiento',
      week: 'Semana',
      weeks2: 'Semanas',
      fullBoardIncluded: 'Pensión completa incluida',
      mostPopular: 'MÁS POPULAR',
      dailyTrainingSessions: '2 sesiones de entrenamiento diarias',
      englishLessons: 'Clases de inglés (4,5 hrs/día)',
      allActivitiesIncluded: 'Todas las actividades incluidas',
      stadiumExcursion: 'Excursión al estadio',
      extendedEvaluationReport: 'Informe de evaluación extendido',
      comprehensiveEvaluation: 'Evaluación completa',
      certificateCompletion: 'Certificado de finalización',
      startDates2026: 'Fechas de Inicio 2026',
      available: 'Disponible',
      experienceClinic: 'Vive la Clínica',
      experienceClinicDesc: 'Mira a nuestros jugadores entrenando con entrenadores de las mejores academias europeas'
    },
    languageSection: {
      title: 'Inmersión Total en Inglés',
      subtitle: 'Aprende inglés de forma natural a través del fútbol y las actividades diarias',
      hoursDaily: '4.5 Horas Diarias',
      description: 'El inglés es el foco central de la experiencia. Todas las actividades, tanto dentro como fuera del aula, están cuidadosamente diseñadas para proporcionar una inmersión lingüística completa en un ambiente dinámico y motivador.',
      feature1: 'Profesores cualificados con certificación TEFL',
      feature2: 'Enfoque 100% comunicativo',
      feature3: 'Entrenamiento realizado completamente en inglés',
      feature4: 'Situaciones de la vida real y actividades prácticas',
      interactiveLearning: 'Aprendizaje Interactivo',
      interactiveLearningDesc: 'Actividades de rol y trabajo en equipo',
      multicultural: 'Multicultural',
      multiculturalDesc: 'Estudiantes de todo el mundo',
      provenResults: 'Resultados Comprobados',
      provenResultsDesc: 'Mejora tangible en semanas',
      certificate: 'Certificado',
      certificateDesc: 'Certificado de finalización incluido',
      howYoullLearn: 'Cómo Aprenderás',
      inClassroom: 'En el Aula',
      inClassroomDesc: 'Lecciones estructuradas con profesores cualificados enfocadas en habilidades comunicativas',
      onField: 'En el Campo',
      onFieldDesc: 'Sesiones de entrenamiento realizadas completamente en inglés con vocabulario técnico',
      dailyLife: 'Vida Diaria',
      dailyLifeDesc: 'Comidas, actividades y tiempo libre todo en inglés para un aprendizaje natural'
    },
    training: {
      trainingProgram: 'Programa de Entrenamiento',
      eliteLevelTraining: 'Entrenamiento de Fútbol de Élite',
      intensity: 'Intensidad',
      studentsPerGroup: 'Estudiantes/Grupo',
      dailySessions: 'Sesiones Diarias',
      whatsIncluded: 'Qué Está Incluido',
      features: [
        '2 sesiones de entrenamiento al día en inglés',
        'Ejercicios tácticos individuales y grupales',
        'Entrenamiento específico para porteros',
        'Análisis de partidos y revisión de video',
        'Partidos amistosos y torneos',
        'Informe de evaluación al final del campamento'
      ]
    },
    astonVilla: {
      heroTitle: 'Programa Fundación Aston Villa',
      heroTagline: 'Experiencia Oficial de Entrenamiento de la Fundación Aston Villa',
      ages: 'Edades',
      hoursTrainingWeek: '20 Horas de Entrenamiento/Semana',
      englishClassesIncluded: 'Clases de Inglés Incluidas',
      viewPrices: 'Ver Precios',
      signUpNow: 'Inscríbete Ahora',
      programOverview: 'Descripción del Programa',
      description: 'El programa de la Fundación Aston Villa ofrece una experiencia exclusiva que combina entrenamiento oficial de la Premier League con inmersión en inglés. Entrena con entrenadores certificados de la Fundación Aston Villa mientras desarrollas habilidades futbolísticas e idiomáticas en un entorno de clase mundial.',
      duration: 'Duración',
      training: 'Entrenamiento',
      english: 'Inglés',
      hrsWeek: 'hrs/semana',
      programHighlights: 'Aspectos Destacados del Programa',
      programHighlightsDesc: 'Experimenta entrenamiento de estándar Premier League combinado con educación completa en inglés',
      features: [
        { title: 'Entrenadores Oficiales de la Fundación', description: 'Dirigido por entrenadores oficiales de la Fundación Aston Villa' },
        { title: '20 Horas Entrenamiento/Semana', description: 'Hasta 20 horas de entrenamiento intensivo dividido en dos sesiones diarias' },
        { title: 'Clases de Inglés', description: 'Hasta 7,5 horas de clases de inglés por semana con grupos por nivel' },
        { title: 'Talleres Deportivos', description: '8 horas de talleres profesionales sobre estrategia, nutrición y prevención de lesiones' }
      ],
      eliteFootballTraining: 'Entrenamiento de Fútbol de Élite',
      eliteFootballTrainingDesc: 'horas por semana de entrenamiento intensivo dirigido por entrenadores oficiales de la Fundación Aston Villa, enfocándose en técnica individual, tácticas de equipo e intensidad competitiva.',
      hoursTrainingWeekLabel: 'Horas Entrenamiento/Semana',
      hoursWorkshopsWeek: 'Horas Talleres/Semana',
      professionalWorkshopsInclude: 'Los Talleres Profesionales Incluyen:',
      workshopTopics: ['Estrategia y tácticas de juego', 'Nutrición deportiva', 'Prevención de lesiones', 'Preparación mental', 'Desarrollo profesional'],
      ledBy: 'Dirigido por',
      workshopLedBy: 'profesionales certificados de la Fundación Aston Villa',
      englishLanguageImmersion: 'Inmersión en el Idioma Inglés',
      dynamicEnglishClasses: 'Clases de Inglés Dinámicas',
      hoursPerWeek: 'Horas por semana:',
      groupSize: 'Tamaño del grupo:',
      levels: 'Niveles:',
      differentGroupsBasedOnTest: 'diferentes grupos basados en prueba inicial',
      certificate: 'Certificado:',
      diplomaUponCompletion: 'Diploma al finalizar',
      englishObjective: 'Nuestras clases de inglés utilizan el deporte como vehículo para la adquisición natural del idioma, haciendo el aprendizaje atractivo y relevante para los intereses de los estudiantes.',
      englishMethodology: 'Clases de inglés dinámicas y centradas en el fútbol diseñadas para involucrar a los jóvenes atletas mientras desarrollan habilidades de comunicación reales.',
      grammarConversation: 'Gramática, conversación y vocabulario técnico en un contexto futbolístico',
      smallGroupsTailored: 'Grupos pequeños adaptados al nivel de cada estudiante',
      initialLevelTest: 'Prueba de nivel inicial para asegurar la ubicación correcta',
      focusOnOvercomingFears: 'Enfoque en superar miedos de comunicación y construir confianza',
      dailySchedule: 'Horario Diario',
      dailyScheduleDesc: 'Un día típico en el Programa de la Fundación Aston Villa',
      schedule: [
        { time: '7:30', activity: 'Despertar', detail: 'Preparación matutina' },
        { time: '8:00', activity: 'Desayuno', location: 'Comedor' },
        { time: '9:00', activity: 'Clases de Inglés', detail: 'Grupos por nivel', location: 'Aulas' },
        { time: '11:00', activity: 'Entrenamiento Matutino', detail: 'Trabajo técnico y táctico', location: 'Campos de Entrenamiento' },
        { time: '13:30', activity: 'Almuerzo', location: 'Comedor' },
        { time: '15:00', activity: 'Entrenamiento Vespertino', detail: 'Preparación de partidos y juegos', location: 'Campos de Entrenamiento' },
        { time: '17:30', activity: 'Tiempo Libre', detail: 'Piscina, sala de juegos o descanso' },
        { time: '19:00', activity: 'Cena', location: 'Comedor' },
        { time: '20:00', activity: 'Actividades Nocturnas', detail: 'Películas de fútbol, actividades de equipo' },
        { time: '22:00', activity: 'Apagar Luces' }
      ],
      whatsIncluded: 'Qué Está Incluido',
      whatsIncludedDesc: 'Todo lo que necesitas para una experiencia inolvidable',
      included: [
        'Alojamiento en pensión completa en Oakham School',
        'Kit oficial de entrenamiento Aston Villa',
        'Hasta 20 horas de entrenamiento de fútbol por semana',
        'Hasta 7,5 horas de clases de inglés',
        '8 horas de talleres deportivos profesionales',
        'Excursión al estadio de la Premier League',
        'Informe de evaluación completo y diploma',
        'Todas las actividades y excursiones',
        'Acceso a instalaciones deportivas',
        'Supervisión 24/7 y asistencia médica'
      ],
      pricingDates: 'Precios y Fechas',
      pricingDatesDesc: 'Elige la duración de tu programa de la Fundación Aston Villa',
      week: 'Semana',
      weeks: 'Semanas',
      fullBoardTrainingKit: 'Pensión completa + kit de entrenamiento incluido',
      upTo20HoursTraining: 'Hasta 20 horas de entrenamiento por semana',
      englishClasses: 'Clases de inglés (7,5 hrs/semana)',
      officialTrainingKit: 'Kit oficial de entrenamiento Aston Villa',
      stadiumExcursion: 'Excursión al estadio',
      sportsWorkshops: 'Talleres deportivos (8 hrs/semana)',
      competitiveMatches: 'Partidos competitivos',
      completeEvaluationReport: 'Informe de evaluación completo',
      mostPopular: 'MÁS POPULAR',
      startDates2026: 'Fechas de Inicio 2026',
      registrationFee: 'Cuota de inscripción:',
      initialDeposit: 'Depósito inicial:',
      freeCancellationUntil: '(seguro de cancelación gratuito incluido — reserva antes del 1 de mayo)',
      experienceProgram: 'Vive el Programa',
      experienceProgramDesc: 'Mira a nuestros jugadores en acción en las sesiones de entrenamiento de la Fundación Aston Villa'
    },
    englishImmersion: {
      badge: 'Inmersión Completa 24/7',
      heroTitle: 'Experiencia de Inmersión Total en Inglés',
      heroSubtitle: 'Cada momento en el campamento es una oportunidad para aprender inglés de forma natural - desde el aula hasta el campo, desde las comidas hasta las actividades',
      countries: 'Más de 30 Países',
      englishEnvironment: '100% Ambiente en Inglés',
      teflCertified: 'Profesores Certificados TEFL',
      viewPrograms: 'Ver Programas',
      signUpNow: 'Inscríbete Ahora',
      moreThanClasses: 'Más que Solo Clases de Inglés',
      moreThanClassesDesc1: 'En nuestro campamento de verano, el inglés es el foco central de toda la experiencia. Todas las actividades, tanto dentro como fuera del aula, están cuidadosamente diseñadas para proporcionar una inmersión lingüística completa en un entorno dinámico y motivador.',
      moreThanClassesDesc2: 'No se trata solo de clases opcionales de inglés - es un programa de inmersión en inglés 24/7 donde cada momento se convierte en una oportunidad de aprendizaje natural.',
      learningQuote: '"El aprendizaje ocurre progresivamente, de forma natural, y casi sin darse cuenta, mientras disfruta de un verano inolvidable."',
      immersionTitle: 'Inmersión en Inglés 24/7',
      immersionDesc: 'Cada aspecto de la vida del campamento está diseñado para sumergirte en inglés desde la mañana hasta la noche',
      classroomTeaching: '8-12 Horas de Enseñanza en Aula',
      classroomTeachingDesc: 'Clases profesionales de inglés por semana con profesores certificados TEFL',
      footballWorkshops: 'Talleres de Fútbol en Inglés',
      footballWorkshopsDesc: 'Todos los talleres relacionados con fútbol se realizan completamente en inglés',
      clubPresentations: 'Presentaciones de Clubes en Inglés',
      clubPresentationsDesc: 'Presentaciones de clubes profesionales y academias en inglés',
      videoAnalysis: 'Análisis de Video en Inglés',
      videoAnalysisDesc: 'Sesiones de entrenamiento y análisis de partidos realizados en inglés',
      trainingSessions: 'Sesiones de Entrenamiento en Inglés',
      trainingSessionsDesc: 'Todo el coaching y entrenamiento se imparte en inglés',
      internationalEnvironment: 'Ambiente Internacional',
      internationalEnvironmentDesc: 'Participantes de más de 30 países creando comunicación natural en inglés',
      englishMonitors: 'Monitores de Habla Inglesa 24/7',
      englishMonitorsDesc: 'El personal y los monitores siempre se comunican en inglés',
      freeTimeActivities: 'Actividades de Tiempo Libre en Inglés',
      freeTimeActivitiesDesc: 'Todas las actividades de ocio y diversión se realizan en inglés',
      professionalClasses: 'Clases Profesionales de Inglés',
      professionalClassesDesc: 'Profesores certificados TEFL impartiendo 4,5 horas de instrucción profesional diaria',
      classSchedule: 'Horario de Clases',
      hoursPerDay: '4,5 horas por día (lunes a viernes)',
      teflCertifiedTeachers: 'Profesores certificados TEFL con cualificaciones profesionales',
      footballFocusedContext: 'Contexto enfocado en fútbol combinando aprendizaje y diversión',
      communicativeApproach: 'Enfoque 100% comunicativo - natural desde el primer día',
      teachingMethodology: 'Metodología de Enseñanza',
      teachingMethodologyDesc1: 'Nuestro enfoque es 100% comunicativo, priorizando la interacción verbal a través de actividades prácticas y situaciones de la vida real.',
      teachingMethodologyDesc2: 'Adaptado a jóvenes de diferentes edades, niveles y nacionalidades, asegurando que todos progresen a su propio ritmo.',
      outsideClassroom: 'Actividades Fuera del Aula',
      outsideClassroomDesc: 'Una variedad de actividades refuerzan lo aprendido durante las lecciones:',
      rolePlayingGames: 'Juegos de rol y simulaciones de la vida diaria',
      teamworkExercises: 'Ejercicios de trabajo en equipo y resolución de problemas',
      funCreativeActivities: 'Actividades divertidas y creativas',
      practicalActivities: 'Actividades prácticas y situaciones de la vida real',
      sportsContinuousLearning: 'El Deporte como Aprendizaje Continuo',
      duringTraining: 'Durante el Entrenamiento',
      duringTrainingDesc: 'Los entrenadores se comunican en inglés, usando vocabulario técnico y cotidiano que refuerza lo que los estudiantes han aprendido en el aula.',
      dailyCampLife: 'En la Vida Diaria del Campamento',
      dailyCampLifeDesc: 'Comidas, talleres, actividades y tiempo libre - todo se realiza en inglés, integrando el idioma en cada momento del día.',
      multiculturalSpace: 'Espacio Multicultural',
      multiculturalSpaceDesc1: 'El campamento es un espacio multicultural, donde jóvenes de diferentes países y culturas conviven.',
      multiculturalSpaceDesc2: 'Con participantes de más de 30 países, esta diversidad enriquece la experiencia y refuerza el uso del inglés como idioma común, promoviendo el aprendizaje en un contexto auténtico, inclusivo y motivador.',
      naturalCommunication: 'Comunicación Natural en Inglés',
      naturalCommunicationDesc: 'Cuando jugadores de Italia, España, Alemania, Países Bajos y más se reúnen, el inglés se convierte en el puente natural - forzando y fomentando la conversación diaria de manera auténtica.',
      ourGoal: 'Nuestro Objetivo para Cada Participante',
      ourGoalDesc: 'Al final del campamento, habrás logrado un progreso tangible en tu viaje con el inglés',
      improveEnglish: 'Mejorar el nivel de inglés de manera tangible',
      gainConfidence: 'Ganar confianza en la comunicación',
      developIntercultural: 'Desarrollar habilidades interculturales',
      bePartOfCommunity: 'Ser parte de una comunidad internacional',
      completeImmersion: 'Experiencia de Inmersión Completa',
      completeImmersionDesc: 'Al final del campamento, los estudiantes habrán tenido una verdadera experiencia de inmersión lingüística, habrán hecho amigos de todo el mundo y habrán progresado significativamente en su dominio del inglés...',
      safeEnvironment: 'Todo en un entorno seguro, deportivo y estimulante.',
      readyToExperience: '¿Listo para Experimentar la Inmersión Total en Inglés?',
      readyToExperienceDesc: 'Únete a nosotros para un verano inolvidable de fútbol y aprendizaje de idiomas',
      viewProgramsPrices: 'Ver Programas y Precios'
    },
    technology: {
      badge: 'Tecnología de Rendimiento Avanzada',
      heroTitle: 'Tecnología y Análisis',
      heroSubtitle: 'Usamos tecnología de vanguardia para mejorar el desarrollo del jugador, proporcionar retroalimentación detallada y medir la mejora a lo largo de la experiencia del campamento',
      veoCamera: 'Cámara Veo',
      veoCameraTagline: 'Grabación de Video Profesional y Transmisión en Vivo',
      videoAnalysis: 'Análisis de Video',
      videoAnalysisTagline: 'Sesiones Interactivas de Revisión de Rendimiento',
      draftApp: 'The Draft App',
      draftAppTagline: 'Evaluación de Jugadores con IA',
      evaluationReports: 'Informes de Evaluación',
      evaluationReportsTagline: 'Informes Personalizados Completos',
      veoCameraSystem: 'Sistema de Cámara Veo',
      veoCameraSystemDesc: 'Todas las sesiones de entrenamiento y partidos se graban con cámaras profesionales Veo, proporcionando material en calidad HD para transmisión en vivo y análisis detallado post-sesión.',
      veoFeature1: 'Graba todas las sesiones de entrenamiento y partidos en calidad HD',
      veoFeature2: 'Capacidad de transmisión en vivo para que las familias miren desde cualquier lugar',
      veoFeature3: 'Seguimiento automático de jugadores y ángulos de cámara tácticos',
      veoFeature4: 'Almacenamiento en la nube para fácil acceso a todo el material',
      veoFeature5: 'Usado para análisis post-partido y post-entrenamiento',
      liveStreamingFamilies: 'Transmisión en Vivo para Familias',
      liveStreamingFamiliesDesc: 'Los padres y familiares pueden ver las sesiones de entrenamiento y partidos en vivo desde cualquier parte del mundo, manteniéndose conectados con la experiencia de su jugador.',
      professionalRecording: 'Grabación Profesional',
      professionalRecordingDesc: 'Cada momento capturado en calidad de transmisión con seguimiento automático de jugadores y ángulos tácticos.',
      quality: 'Calidad',
      streaming: 'Transmisión',
      storage: 'Almacenamiento',
      access: 'Acceso',
      professionalVideoAnalysis: 'Análisis de Video Profesional',
      professionalVideoAnalysisDesc: 'Varias veces por semana, un analista de fútbol profesional revisa el material con los jugadores y entrenadores en sesiones interactivas donde los jugadores participan activamente.',
      analysisFeature1: 'Varias sesiones de análisis profesional por semana',
      analysisFeature2: 'Sesiones interactivas con participación activa del jugador',
      analysisFeature3: 'Evaluación de video pre-campamento con llamada familiar incluida',
      analysisFeature4: 'Enfoque en áreas individuales de mejora',
      analysisFeature5: 'Análisis táctico, técnico y posicional',
      analysisFeature6: 'Retroalimentación del entrenador y analista en tiempo real',
      personalizedFocus: 'Enfoque Personalizado',
      personalizedFocusDesc: 'Cada jugador recibe atención individual, con análisis adaptado a su posición específica, estilo de juego y áreas de mejora.',
      interactiveAnalysis: 'Sesiones de Análisis Interactivas',
      preCampEvaluation: 'Evaluación Pre-Campamento',
      preCampEvaluationDesc: 'Envía un video antes de que comience el campamento. Recibe una llamada personalizada con la familia presente para discutir áreas de enfoque y objetivos de mejora.',
      duringCampSessions: 'Sesiones Durante el Campamento',
      duringCampSessionsDesc: 'Múltiples sesiones semanales con analistas profesionales revisando tu material, explicando mejoras y analizando diferentes situaciones de juego.',
      activeParticipation: 'Participación Activa',
      activeParticipationDesc: 'Los jugadores participan activamente en las sesiones, discutiendo tácticas, haciendo preguntas y entendiendo su rendimiento en detalle.',
      comprehensiveReports: 'Informes de Evaluación Completos',
      comprehensiveReportsDesc: 'Al final del campamento, cada jugador recibe un informe de evaluación personalizado completo',
      reportIncludes: 'Tu Informe Incluye:',
      technicalSkills: 'Evaluación de Habilidades Técnicas',
      technicalSkillsDesc: 'Evaluación detallada de control de balón, pases, tiros y regate',
      tacticalUnderstanding: 'Comprensión Táctica',
      tacticalUnderstandingDesc: 'Análisis de posicionamiento, toma de decisiones e inteligencia de juego',
      physicalPerformance: 'Rendimiento Físico',
      physicalPerformanceDesc: 'Velocidad, resistencia, fuerza y capacidades atléticas',
      mentalSocialSkills: 'Habilidades Mentales y Sociales',
      mentalSocialSkillsDesc: 'Liderazgo, trabajo en equipo, actitud y capacidad de ser entrenado',
      recommendations: 'Recomendaciones',
      recommendationsDesc: 'Áreas específicas en las que enfocarse y sugerencias de entrenamiento para el desarrollo continuo',
      sampleReport: 'Informe de Ejemplo',
      multiPageAnalysis: 'Análisis completo de múltiples páginas',
      reportDelivered: 'Informe de evaluación profesional entregado digitalmente',
      viewFullReport: 'Ver Informe Completo',
      downloadSampleReport: 'Descargar Informe de Ejemplo (PDF)',
      aiPoweredAssessment: 'The Draft App: Evaluación con IA',
      aiPoweredAssessmentDesc: 'Usamos tecnología de IA de vanguardia para evaluar a los jugadores en diferentes habilidades físicas y técnicas antes, durante y después del campamento',
      howItWorks: 'Cómo Funciona',
      downloadApp: 'Descarga la App',
      downloadAppDesc: 'Disponible para dispositivos iOS y Android',
      setupTestScene: 'Configura la Escena de Prueba',
      setupTestSceneDesc: 'Usa conos de fútbol para regate, una portería para tiros potentes y otras configuraciones simples',
      completeTests: 'Completa las Pruebas',
      completeTestsDesc: 'Los modelos de IA evalúan tu rendimiento usando visión por computadora',
      getResults: 'Obtén Resultados',
      getResultsDesc: 'Recibe comparativas apropiadas para tu edad y sigue la mejora a lo largo del tiempo',
      whatWeMeasure: 'Qué Medimos',
      appPreview: 'Vista Previa de la App',
      draftFeature1: 'Evaluación de habilidades físicas con IA',
      draftFeature2: 'Evaluación de habilidades técnicas usando visión por computadora',
      draftFeature3: 'Comparativas de rendimiento apropiadas para la edad',
      draftFeature4: 'Las pruebas incluyen regate, tiros potentes y más',
      draftFeature5: 'Configuración fácil con solo conos de fútbol y una portería',
      draftFeature6: 'Sigue el progreso antes, durante y después del campamento',
      trackProgress: 'Sigue Tu Progreso',
      trackProgressDesc: 'Pruébate antes del campamento, durante el campamento y después del campamento para ver mejoras medibles en tus habilidades. La IA tiene en cuenta tu edad y proporciona comparativas personalizadas.',
      objectiveAssessment: 'Evaluación Objetiva Basada en Datos',
      objectiveAssessmentDesc: 'La tecnología de IA elimina la subjetividad y proporciona mediciones precisas y consistentes de tus habilidades',
      experienceTechnology: 'Experimenta el Entrenamiento Mejorado con Tecnología',
      experienceTechnologyDesc: 'Únete a un campamento donde la tecnología de vanguardia se encuentra con el coaching profesional para el máximo desarrollo del jugador',
      viewProgramsPrices: 'Ver Programas y Precios',
      signUpNow: 'Inscríbete Ahora'
    },
    aboutOakham: {
      heroTitle: 'Oakham School',
      heroDesc: 'Una prestigiosa escuela británica de internado que proporciona instalaciones de clase mundial para nuestros campamentos de fútbol',
      perfectLocation: 'Ubicación Perfecta',
      locationTown: 'Oakham',
      locationRegion: 'Rutland, Inglaterra',
      locationFromLondon: '2 horas al norte de Londres',
      nearestAirports: 'Aeropuertos Más Cercanos',
      airports: [
        'Aeropuerto de East Midlands (45 min)',
        'Aeropuerto de Birmingham (1 hora)'
      ],
      accommodation: 'Alojamiento',
      rooms: 'Habitaciones',
      roomTypes: 'Habitaciones compartidas (dobles o triples), habitaciones individuales limitadas disponibles',
      bathrooms: 'Baños:',
      bathroomsDesc: 'Instalaciones compartidas en cada planta',
      amenities: 'Comodidades',
      amenitiesList: [
        'Supervisión y seguridad 24/7',
        'Servicio diario de limpieza de habitaciones',
        'Cambio de ropa de cama y toallas',
        'WiFi gratuito en todo el recinto',
        'Zonas comunes con TV y juegos',
        'Servicio de lavandería disponible'
      ],
      dining: 'Comedor',
      mealsNutrition: 'Comidas y Nutrición',
      meals: 'Comidas:',
      mealsDesc: 'Tres comidas nutritivas al día más snacks',
      cuisine: 'Cocina:',
      cuisineDesc: 'Menú internacional con clásicos británicos',
      dietary: 'Dietético:',
      dietaryDesc: 'Se atienden todos los requisitos dietéticos',
      features: 'Características',
      diningFeatures: [
        'Equipo de catering profesional',
        'Ingredientes frescos de origen local',
        'Nutrición equilibrada para atletas',
        'Opciones vegetarianas y veganas',
        'Comidas libres de alérgenos disponibles',
        'Comedor con arquitectura impresionante'
      ],
      worldClassFacilities: 'Instalaciones de Clase Mundial',
      sportsFacilities: 'Instalaciones Deportivas',
      sportsFeatures: [
        'Múltiples campos de césped natural',
        'Campo de césped artificial de tamaño completo',
        'Piscina de tamaño olímpico',
        'Gimnasio totalmente equipado',
        'Pabellón deportivo cubierto',
        'Vestuarios y duchas'
      ],
      academicFacilities: 'Instalaciones Académicas',
      academicFeatures: [
        'Aulas modernas para clases de inglés',
        'Laboratorios de idiomas',
        'Biblioteca y áreas de estudio',
        'Sala de análisis de video'
      ],
      recreational: 'Recreativas',
      recreationalFeatures: [
        'Sala de juegos con billar y ping-pong',
        'Salones de TV',
        'Zonas de juegos PlayStation',
        'Espacios de recreación al aire libre'
      ],
      safetySecurity: 'Seguridad y Protección',
      safetyDesc: 'La seguridad de tu hijo es nuestra máxima prioridad. Oakham proporciona un entorno seguro y supervisado con presencia de personal 24/7, monitoreo CCTV y procedimientos completos de protección.',
      staffSupervision: 'Supervisión de Personal',
      townEnvironment: 'Entorno del Pueblo',
      safe: 'Seguro',
      medicalCare: 'Atención Médica',
      onSite: 'En el Lugar'
    },
    prices: {
      heroTitle: 'Precios y Fechas',
      heroSubtitle: 'Duraciones flexibles para adaptarse a tu horario. Todos los precios incluyen alojamiento, comidas, entrenamiento y clases de inglés.',
      highPerformanceClinic: 'Clínica de Alto Rendimiento',
      chooseDuration: 'Elige la duración perfecta para tu experiencia de campamento de verano',
      week: 'Semana',
      weeks: 'Semanas',
      oneWeek: '1 Semana',
      twoWeeks: '2 Semanas',
      threeWeeks: '3 Semanas',
      fourWeeks: '4 Semanas',
      fullBoardIncluded: 'Pensión completa incluida',
      mostPopular: 'MÁS POPULAR',
      signUpNow: 'Inscríbete Ahora',
      startDates2026: 'Fechas de Inicio 2026',
      available: 'Disponible',
      soldOut: 'Agotado',
      spotsLeft: 'plazas disponibles',
      onlyXSpotsLeft: '¡Solo quedan {x} plazas!',
      limitedAvailability: 'Disponibilidad Limitada',
      clinicSoldOut: 'Clinic — Agotado',
      astonVillaAvailable: 'Aston Villa — {x} plazas',
      astonVillaProgram: 'Programa Fundación Aston Villa',
      astonVillaDesc: 'Experiencia oficial de entrenamiento de la Fundación Aston Villa',
      fullBoardTrainingKit: 'Pensión completa + kit de entrenamiento incluido',
      registrationInfo: 'Información de Inscripción',
      registrationFee: 'Cuota de Inscripción',
      initialDeposit: 'Depósito Inicial',
      freeCancellation: 'Seguro de cancelación gratuito incluido (reserva antes del 1 de mayo)',
      paymentOptions: 'Opciones de Pago',
      gbpEurUsd: 'GBP, EUR o USD',
      paymentsAccepted: 'Pagos aceptados en GBP, EUR o USD al tipo de cambio actual.',
      groupDiscounts: 'Descuentos de grupo disponibles para familiares o amigos. Contáctanos para más detalles.',
      whatsIncluded: 'Qué Está Incluido en Todos los Precios',
      accommodationTitle: 'Alojamiento',
      fullBoard: 'Pensión completa (3 comidas + snacks)',
      sharedAccommodation: 'Alojamiento compartido',
      linenTowels: 'Ropa de cama y toallas',
      supervision: 'Supervisión 24/7',
      trainingEducation: 'Entrenamiento y Educación',
      dailyTrainingSessions: '2 sesiones de entrenamiento diarias',
      englishLessons: 'Clases de inglés (4,5 hrs/día)',
      uefaCoaches: 'Entrenadores con licencia UEFA',
      evaluationReport: 'Informe de evaluación',
      activitiesExtras: 'Actividades y Extras',
      stadiumExcursion: 'Excursión al estadio',
      facilitiesAccess: 'Acceso a todas las instalaciones',
      eveningActivities: 'Actividades nocturnas',
      freeWifi: 'WiFi gratuito',
      readyToSecure: '¿Listo para asegurar tu plaza?',
      // Clinic features
      clinicFeatures: {
        '20hours': '20+ horas de entrenamiento de fútbol',
        '40hours': '40+ horas de entrenamiento de fútbol',
        '60hours': '60+ horas de entrenamiento de fútbol',
        '80hours': '80+ horas de entrenamiento de fútbol',
        'english45': '4,5 horas de inglés diarias',
        'fullBoard': 'Alojamiento en pensión completa',
        'stadiumExcursion': 'Excursión al estadio',
        'stadiumExcursions2': '2 excursiones a estadios',
        'stadiumExcursions3': '3 excursiones a estadios',
        'stadiumExcursions4': '4 excursiones a estadios',
        'tournament': 'Torneo de fin de campamento',
        'analysisReport': 'Informe de análisis de rendimiento',
        'completeAnalysis': 'Análisis completo de rendimiento',
        'certificate': 'Certificado de finalización'
      },
      // Aston Villa features
      villaFeatures: {
        'officialCoaching': 'Entrenamiento oficial de Aston Villa',
        '20hours': '20+ horas de entrenamiento',
        '40hours': '40+ horas de entrenamiento',
        'villaParkVisit': 'Visita al estadio Villa Park',
        'fullKit': 'Kit completo de Aston Villa',
        'evaluation': 'Evaluación de rendimiento',
        'certificate': 'Certificado de finalización'
      }
    },
    contact: {
      heroTitle: 'Ponte en Contacto',
      heroSubtitle: '¿Tienes preguntas sobre nuestros programas? Estamos aquí para ayudarte a encontrar la experiencia perfecta de campamento de fútbol.',
      sendMessage: 'Envíanos un Mensaje',
      fullName: 'Nombre Completo',
      emailAddress: 'Correo Electrónico',
      phoneNumber: 'Número de Teléfono',
      interestedIn: 'Interesado En',
      selectProgram: 'Selecciona un programa',
      highPerformanceClinic: 'Clínica de Alto Rendimiento',
      astonVillaProgram: 'Programa Aston Villa',
      bothPrograms: 'Ambos Programas',
      generalInquiry: 'Consulta General',
      message: 'Mensaje',
      messagePlaceholder: 'Cuéntanos sobre tu consulta, la edad del jugador, fechas preferidas o cualquier pregunta que tengas...',
      sendMessageBtn: 'Enviar Mensaje',
      sending: 'Enviando...',
      successMessage: '¡Gracias por tu mensaje! Nos pondremos en contacto contigo pronto.',
      errorMessage: 'Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo.',
      emailUs: 'Escríbenos',
      emailResponse: 'Normalmente respondemos en 24 horas',
      callUs: 'Llámanos',
      callHours: 'Lunes - Viernes: 9am - 6pm GMT',
      visitUs: 'Visítanos',
      quickLinks: 'Enlaces Rápidos',
      viewPricesDates: 'Ver Precios y Fechas',
      clinicProgramDetails: 'Detalles del Programa Clínica',
      aboutOakhamSchool: 'Sobre Oakham School',
      signUpNow: 'Inscríbete Ahora'
    },
    signUp: {
      heroTitle: 'Inscríbete Ahora',
      heroSubtitle: 'Comienza tu viaje hacia la excelencia futbolística. Completa el formulario a continuación para inscribirte para el verano 2026.',
      parentGuardianInfo: 'Información del Padre/Tutor',
      fullName: 'Nombre Completo',
      emailAddress: 'Correo Electrónico',
      phoneNumber: 'Número de Teléfono',
      playerInfo: 'Información del Jugador',
      playerFullName: 'Nombre Completo del Jugador',
      age: 'Edad',
      gender: 'Género',
      selectGender: 'Selecciona género',
      male: 'Masculino',
      female: 'Femenino',
      programSelection: 'Selección de Programa',
      program: 'Programa',
      selectProgram: 'Selecciona un programa',
      highPerformanceClinic: 'Clínica de Alto Rendimiento',
      astonVillaProgram: 'Programa Aston Villa',
      duration: 'Duración',
      selectDuration: 'Selecciona duración',
      selectProgramFirst: 'Selecciona un programa primero',
      startDate: 'Fecha de Inicio',
      selectStartDate: 'Selecciona fecha de inicio',
      additionalInfo: 'Información Adicional',
      medicalConditions: 'Condiciones Médicas o Alergias',
      medicalPlaceholder: 'Por favor lista cualquier condición médica, alergias o medicamentos',
      dietaryRequirements: 'Requisitos Dietéticos',
      dietaryPlaceholder: 'Vegetariano, vegano, halal, alergias, etc.',
      emergencyContact: 'Contacto de Emergencia (si es diferente del padre)',
      emergencyPlaceholder: 'Nombre y número de teléfono',
      whatHappensNext: '¿Qué Pasa Después?',
      step1: 'Recibirás un correo de confirmación en 24 horas',
      step2: 'Te enviaremos documentos de registro y detalles de pago',
      step3: 'Completa el pago para asegurar tu plaza',
      step4: 'Recibe el paquete de bienvenida con detalles del campamento 4 semanas antes del inicio',
      completeRegistration: 'Completar Inscripción',
      submitting: 'Enviando...',
      successMessage: '¡Gracias por tu inscripción! Nos pondremos en contacto contigo pronto con los detalles de confirmación.',
      errorMessage: 'Hubo un error al procesar tu inscripción. Por favor, inténtalo de nuevo.',
      termsAgreement: 'Al enviar este formulario, aceptas nuestros términos y condiciones y política de privacidad.'
    },
    legal: {
      termsTitle: 'Términos y Condiciones',
      privacyTitle: 'Política de Privacidad',
      cookieTitle: 'Política de Cookies',
      lastUpdated: 'Última Actualización:',
      introduction: '1. Introducción',
      termsPlaceholder: 'Por favor copia el contenido de Términos y Condiciones de:',
      privacyPlaceholder: 'Por favor copia el contenido de la Política de Privacidad de:',
      cookiePlaceholder: 'Por favor copia el contenido de la Política de Cookies de:',
      termsIncludes: 'Esta página debe incluir todos los términos y condiciones que cubren:',
      privacyIncludes: 'Esta página debe incluir toda la información de política de privacidad que cubre:',
      cookieIncludes: 'Esta página debe incluir toda la información de política de cookies que cubre:',
      servicesOffered: 'Servicios ofrecidos',
      bookingPayment: 'Términos de reserva y pago',
      cancellationPolicies: 'Políticas de cancelación',
      campRules: 'Reglas y regulaciones del campamento',
      liabilityLimitations: 'Limitaciones de responsabilidad',
      userResponsibilities: 'Responsabilidades del usuario',
      personalDataCollected: 'Qué datos personales se recopilan',
      dataUsedStored: 'Cómo se usan y almacenan los datos',
      dataRetention: 'Períodos de retención de datos',
      userRights: 'Derechos del usuario (acceso, edición, eliminación)',
      dataSecurity: 'Medidas de seguridad de datos',
      thirdPartySharing: 'Compartición de datos con terceros',
      contactInfo: 'Información de contacto para consultas de datos',
      whatCookiesAre: 'Qué son las cookies y cómo funcionan',
      typesOfCookies: 'Tipos de cookies usadas en el sitio web',
      purposeOfCookies: 'Propósito de cada tipo de cookie',
      manageCookies: 'Cómo gestionar las preferencias de cookies',
      thirdPartyCookies: 'Cookies de terceros',
      cookieConsent: 'Mecanismos de consentimiento de cookies',
      campSpecificPolicies: '2. Políticas Específicas del Campamento',
      campSpecificDesc: 'Incluye detalles sobre depósitos, calendarios de pago, políticas de reembolso y cualquier término específico del programa.',
      codeOfConduct: '3. Código de Conducta',
      codeOfConductDesc: 'Incluye reglas del campamento sobre comportamiento, seguridad, artículos prohibidos y consecuencias por violaciones.',
      dataCollection: '2. Recopilación de Datos',
      dataCollectionDesc: 'Incluye detalles sobre qué tipos de información personal se recopilan (nombres, fechas de nacimiento, información de contacto, información médica, etc.).',
      yourRights: '3. Tus Derechos',
      yourRightsDesc: 'Incluye información sobre derechos GDPR y cómo los usuarios pueden ejercerlos.',
      typesOfCookiesSection: '2. Tipos de Cookies',
      typesOfCookiesDesc: 'Incluye detalles sobre cookies esenciales, cookies de rendimiento, cookies funcionales y cookies de segmentación/publicidad.',
      managingCookies: '3. Gestión de Cookies',
      managingCookiesDesc: 'Incluye información sobre cómo los usuarios pueden controlar y eliminar cookies a través de la configuración de su navegador.',
      adminNoteTerms: 'Nota al Administrador: Por favor reemplaza este contenido de marcador de posición con los Términos y Condiciones reales. El contenido debe copiarse en su totalidad para garantizar el cumplimiento legal y la precisión.',
      adminNotePrivacy: 'Nota al Administrador: Por favor reemplaza este contenido de marcador de posición con la Política de Privacidad real. El contenido debe copiarse en su totalidad para garantizar el cumplimiento legal con GDPR y otras regulaciones de privacidad.',
      adminNoteCookie: 'Nota al Administrador: Por favor reemplaza este contenido de marcador de posición con la Política de Cookies real. El contenido debe copiarse en su totalidad para garantizar el cumplimiento legal con las leyes y regulaciones de cookies de la UE.'
    }
  },
  fr: {
    nav: {
      clinic: 'Clinique',
      astonVilla: 'Aston Villa',
      englishImmersion: 'Immersion Anglaise Totale',
      technology: 'Technologie et Analyse',
      aboutOakham: 'À Propos d\'Oakham',
      prices: 'Prix',
      contact: 'Contact',
      signUp: 'S\'inscrire Maintenant'
    },
    hero: {
      badge: 'Plus de 20 Ans d\'Excellence',
      title: 'Camps de Football d\'Élite à Oakham, Angleterre',
      subtitle: 'Deux programmes exceptionnels. Un emplacement de classe mondiale. Plus de 20 ans d\'excellence.',
      exploreProgramsBtn: 'Explorer les Programmes',
      viewPricesBtn: 'Voir les Prix'
    },
    home: {
      tech: {
        badge: 'Technologie de Pointe',
        title: 'Entraînez-vous Plus Intelligemment avec la Technologie',
        subtitle: 'Nous utilisons les dernières technologies pour suivre, analyser et accélérer votre développement footballistique',
        veoTitle: 'Système de Caméra Veo',
        veoDesc: 'Enregistrement professionnel des matchs avec analyse IA et moments forts automatiques',
        draftTitle: 'The Draft App',
        draftDesc: 'Évaluation des capacités physiques et techniques par IA avec benchmarks adaptés à l\'âge',
        reportsTitle: 'Rapports d\'Évaluation',
        reportsDesc: 'Analyse complète sur plusieurs pages avec recommandations personnalisées pour un développement continu',
        cta: 'Explorer Notre Technologie'
      }
    },
    programs: {
      title: 'Choisissez Votre Programme',
      subtitle: 'Deux programmes de football de classe mondiale au cœur de l\'Angleterre. Tous deux offrant un entraînement d\'élite, une immersion en anglais et des expériences inoubliables.',
      from: 'À partir de',
      viewDetails: 'Voir les Détails du Programme',
      learnMore: 'En Savoir Plus',
      comingSoon: 'Bientôt Disponible',
      // Program cards data
      clinic: {
        name: 'Clinique Haute Performance',
        tagline: 'Entraînement d\'élite avec des entraîneurs des meilleures académies européennes',
        highlights: [
          'Entraîneurs licenciés UEFA des meilleures académies européennes',
          'Immersion en anglais (4,5 heures par jour)',
          'Entraînement de haute intensité (4,5/5)',
          'Âges 11-17, garçons uniquement',
          'Focus sur le développement des compétences individuelles'
        ]
      },
      astonVilla: {
        name: 'Programme Fondation Aston Villa',
        tagline: 'Coaching officiel de la Fondation Aston Villa en Angleterre',
        highlights: [
          'Entraîneurs officiels de la Fondation Aston Villa',
          '20 heures d\'entraînement + 8 heures d\'ateliers par semaine',
          'Cours d\'anglais (7,5 heures/semaine)',
          'Âges 10-17, tous niveaux bienvenus',
          'Excursion au stade de Premier League'
        ]
      }
    },
    whyOakham: {
      title: 'Pourquoi S\'entraîner à Oakham?',
      subtitle: 'Plus de 20 ans d\'excellence dans le développement des jeunes footballeurs',
      reasons: [
        {
          title: 'Plus de 20 Ans d\'Expérience',
          description: 'Deux décennies de développement réussi de jeunes footballeurs du monde entier'
        },
        {
          title: 'Emplacement Parfait',
          description: 'Ville historique au cœur de l\'Angleterre, à 2 heures de Londres, environnement sûr et accueillant'
        },
        {
          title: 'Communauté Internationale',
          description: 'Nous accueillons des joueurs de plus de 30 pays, créant une expérience footballistique vraiment mondiale'
        },
        {
          title: 'Installations Premium',
          description: 'Terrains d\'entraînement de classe mondiale, hébergement moderne et excellente restauration à Oakham School'
        }
      ]
    },
    activities: {
      title: 'Visites de Stades et Activités',
      subtitle: 'Découvrez la culture du football anglais au-delà du terrain d\'entraînement',
      stadiumVisits: [
        {
          name: 'Stade de Wembley',
          description: 'Visitez le stade national emblématique de l\'Angleterre'
        },
        {
          name: 'Stades de Premier League',
          description: 'Découvrez le domicile des meilleurs clubs anglais'
        }
      ],
      freetimeTitle: 'Activités de Temps Libre',
      freetimeActivities: [
        'Natation dans une piscine olympique',
        'Salle de jeux avec billard et ping-pong',
        'Salon PlayStation et TV',
        'Accès à la salle de sport',
        'Présentations de football en soirée',
        'Activités de team-building'
      ]
    },
    testimonials: {
      title: 'Ce Que Disent les Parents',
      subtitle: 'Écoutez les familles qui ont vécu nos camps',
      items: [
        {
          name: 'Brenda',
          role: 'Mère de Jerónimo C. G., 15 ans',
          country: 'Espagne',
          text: 'Tout était génial. Mon fils était très heureux de passer du temps là-bas et d\'apprendre. Pour résumer en un mot : excellent. Je pense que le camp a tout ce dont les enfants ont besoin pour être heureux – apprendre et s\'amuser.',
          program: 'Clinique Haute Performance'
        },
        {
          name: 'Nouf',
          role: 'Père de Zayed A., 13 ans',
          country: 'Royaume-Uni',
          text: 'Une excellente expérience, une réponse rapide, efficace et professionnelle. Eduard, le superviseur du camp, était très solidaire et serviable.',
          program: 'Clinique Haute Performance'
        },
        {
          name: 'Dolores',
          role: 'Mère d\'Oriol N. P., 18 ans',
          country: 'Espagne',
          text: 'L\'expérience était incroyable ! Nous prévoyons définitivement de revenir, et si c\'était à notre fils de décider, il resterait toute l\'année ! 10 sur 10 !',
          program: 'Clinique Haute Performance'
        },
        {
          name: 'Giuliana T.',
          role: 'Mère de Riccardo Z., 17 ans',
          country: 'Italie',
          text: 'Ce fut une expérience merveilleuse pour Riccardo, il a rencontré beaucoup de gens et a pu parler plusieurs langues avec des personnes de différents pays européens.',
          program: 'Clinique Haute Performance'
        }
      ]
    },
    footer: {
      about: 'Camps d\'été de football et d\'anglais de premier ordre au cœur de l\'Angleterre.',
      contact: 'Contact',
      legal: 'Légal',
      quickLinks: 'Liens Rapides',
      terms: 'Conditions Générales',
      privacyPolicy: 'Politique de Confidentialité',
      cookiePolicy: 'Politique de Cookies',
      copyright: '© 2026 Oakham Football Camps. Tous droits réservés.',
      ctaTitle: 'Prêt à Commencer Votre Aventure Footballistique?',
      ctaSubtitle: 'Rejoignez des centaines de jeunes joueurs qui ont transformé leurs compétences dans la meilleure académie de football d\'Angleterre',
      getQuote: 'Demander un Devis',
      contactUs: 'Nous Contacter'
    },
    clinic: {
      heroTitle: 'Clinique Haute Performance',
      heroSubtitle: 'Entraînement de football d\'élite avec les meilleurs entraîneurs des académies européennes et immersion totale en anglais',
      viewPrices: 'Voir les Prix',
      signUpNow: 'S\'inscrire Maintenant',
      programOverview: 'Aperçu du Programme',
      programOverviewDesc: 'Entraînement de style professionnel conçu pour les joueurs avancés/élite avec une technique solide et une intelligence de jeu avancée. Entraînez-vous avec des entraîneurs licenciés UEFA des meilleures académies européennes.',
      ages: 'Âges',
      duration: 'Durée',
      intensity: 'Intensité',
      english: 'Anglais',
      weeks: 'Semaines',
      hrsDay: 'hrs/jour',
      programAtGlance: 'Le Programme en Détail',
      programAtGlanceDesc: 'Tout ce dont vous avez besoin pour une expérience inoubliable de football et d\'apprentissage',
      features: [
        { category: 'Tranche d\'Âge', title: 'Garçons 11-17 Ans', description: 'Groupés par âge et niveau pour un développement optimal' },
        { category: 'Intensité', title: 'Haute Performance', description: 'Note d\'intensité 4,5/5 pour un développement d\'élite' },
        { category: 'Staff Technique', title: 'Entraîneurs Licenciés UEFA', description: 'Des meilleures académies européennes dont La Liga et Bundesliga' },
        { category: 'Hébergement', title: 'Oakham School', description: 'Pension complète dans un cadre d\'école privée historique' },
        { category: 'Langue', title: 'Immersion Anglaise 24/7', description: 'Avec 4,5 heures de cours structurés quotidiens' },
        { category: 'Évaluation', title: 'Rapports de Performance', description: 'Évaluation complète des compétences et des progrès' }
      ],
      trainingTitle: 'Méthodologie d\'Entraînement d\'Élite',
      trainingDesc: 'Notre programme d\'entraînement est conçu pour défier et développer les joueurs au plus haut niveau',
      technicalSkills: 'Compétences Techniques',
      technicalSkillsDesc: 'Contrôle du ballon, précision des passes et techniques de tir',
      tacticalAwareness: 'Conscience Tactique',
      tacticalAwarenessDesc: 'Lecture du jeu, positionnement et prise de décision',
      physicalConditioning: 'Préparation Physique',
      physicalConditioningDesc: 'Vitesse, agilité, force et endurance',
      mentalDevelopment: 'Développement Mental',
      mentalDevelopmentDesc: 'Concentration, confiance et mentalité compétitive',
      coachingExcellence: 'Excellence en Coaching',
      coachingExcellenceDesc: 'Nos entraîneurs apportent leur expérience des meilleures académies de football d\'Europe',
      academiesTitle: 'Académies Partenaires',
      academiesDesc: 'Nos entraîneurs se sont formés dans ces académies de renommée mondiale',
      scheduleTitle: 'Programme Quotidien',
      scheduleDesc: 'Une journée typique à la Clinique Haute Performance',
      schedule: [
        { time: '7:30', activity: 'Réveil', detail: 'Préparation matinale' },
        { time: '8:00', activity: 'Petit-déjeuner', location: 'Réfectoire' },
        { time: '9:00', activity: 'Entraînement Matinal', detail: 'Travail technique et tactique', location: 'Terrains d\'entraînement' },
        { time: '11:30', activity: 'Cours d\'Anglais', detail: 'Groupes par niveau', location: 'Salles de classe' },
        { time: '13:30', activity: 'Déjeuner', location: 'Réfectoire' },
        { time: '15:00', activity: 'Entraînement Après-midi', detail: 'Préparation des matchs et jeux', location: 'Terrains d\'entraînement' },
        { time: '17:30', activity: 'Temps Libre', detail: 'Piscine, jeux, repos' },
        { time: '19:00', activity: 'Dîner', location: 'Réfectoire' },
        { time: '20:00', activity: 'Activités du Soir', detail: 'Films, activités d\'équipe' },
        { time: '22:00', activity: 'Extinction des Feux' }
      ],
      pricingDates: 'Prix et Dates',
      pricingDatesDesc: 'Choisissez la durée parfaite pour votre expérience à la Clinique Haute Performance',
      week: 'Semaine',
      weeks2: 'Semaines',
      fullBoardIncluded: 'Pension complète incluse',
      mostPopular: 'PLUS POPULAIRE',
      dailyTrainingSessions: '2 séances d\'entraînement quotidiennes',
      englishLessons: 'Cours d\'anglais (4,5 hrs/jour)',
      allActivitiesIncluded: 'Toutes les activités incluses',
      stadiumExcursion: 'Excursion au stade',
      extendedEvaluationReport: 'Rapport d\'évaluation étendu',
      comprehensiveEvaluation: 'Évaluation complète',
      certificateCompletion: 'Certificat de fin',
      startDates2026: 'Dates de Début 2026',
      available: 'Disponible',
      experienceClinic: 'Vivez la Clinique',
      experienceClinicDesc: 'Regardez nos joueurs s\'entraîner avec les meilleurs entraîneurs des académies européennes'
    },
    languageSection: {
      title: 'Immersion Complète en Anglais',
      subtitle: 'Apprenez l\'anglais naturellement à travers le football et les activités quotidiennes',
      hoursDaily: '4,5 Heures par Jour',
      description: 'L\'anglais est au cœur de l\'expérience. Toutes les activités, tant en classe qu\'en dehors, sont soigneusement conçues pour offrir une immersion linguistique complète dans un environnement dynamique et motivant.',
      feature1: 'Professeurs qualifiés certifiés TEFL',
      feature2: 'Approche 100% communicative',
      feature3: 'Entraînement entièrement en anglais',
      feature4: 'Situations réelles et activités pratiques',
      interactiveLearning: 'Apprentissage Interactif',
      interactiveLearningDesc: 'Jeux de rôle et activités en équipe',
      multicultural: 'Multiculturel',
      multiculturalDesc: 'Étudiants du monde entier',
      provenResults: 'Résultats Prouvés',
      provenResultsDesc: 'Amélioration tangible en quelques semaines',
      certificate: 'Certificat',
      certificateDesc: 'Certificat de fin de stage inclus',
      howYoullLearn: 'Comment Vous Apprendrez',
      inClassroom: 'En Classe',
      inClassroomDesc: 'Cours structurés avec des professeurs qualifiés axés sur les compétences de communication',
      onField: 'Sur le Terrain',
      onFieldDesc: 'Séances d\'entraînement entièrement en anglais avec vocabulaire technique',
      dailyLife: 'Vie Quotidienne',
      dailyLifeDesc: 'Repas, activités et temps libre tout en anglais pour un apprentissage naturel'
    },
    training: {
      trainingProgram: 'Programme d\'Entraînement',
      eliteLevelTraining: 'Entraînement de Football d\'Élite',
      intensity: 'Intensité',
      studentsPerGroup: 'Étudiants/Groupe',
      dailySessions: 'Séances Quotidiennes',
      whatsIncluded: 'Ce Qui Est Inclus',
      features: [
        '2 séances d\'entraînement par jour en anglais',
        'Exercices tactiques individuels et en groupe',
        'Entraînement spécifique pour gardiens',
        'Analyse de matchs et revue vidéo',
        'Matchs amicaux et tournois',
        'Rapport d\'évaluation en fin de camp'
      ]
    },
    astonVilla: {
      heroTitle: 'Programme Fondation Aston Villa',
      heroTagline: 'Expérience Officielle d\'Entraînement de la Fondation Aston Villa',
      ages: 'Âges',
      hoursTrainingWeek: '20 Heures d\'Entraînement/Semaine',
      englishClassesIncluded: 'Cours d\'Anglais Inclus',
      viewPrices: 'Voir les Prix',
      signUpNow: 'S\'inscrire Maintenant',
      programOverview: 'Aperçu du Programme',
      description: 'Le programme de la Fondation Aston Villa offre une expérience exclusive combinant coaching officiel de Premier League et immersion en anglais. Entraînez-vous avec des entraîneurs certifiés de la Fondation Aston Villa tout en développant vos compétences footballistiques et linguistiques dans un environnement de classe mondiale.',
      duration: 'Durée',
      training: 'Entraînement',
      english: 'Anglais',
      hrsWeek: 'hrs/semaine',
      programHighlights: 'Points Forts du Programme',
      programHighlightsDesc: 'Découvrez un entraînement aux standards de Premier League combiné à une éducation complète en anglais',
      features: [
        { title: 'Entraîneurs Officiels de la Fondation', description: 'Dirigé par des entraîneurs officiels de la Fondation Aston Villa' },
        { title: '20 Heures Entraînement/Semaine', description: 'Jusqu\'à 20 heures d\'entraînement intensif réparties en deux sessions quotidiennes' },
        { title: 'Cours d\'Anglais', description: 'Jusqu\'à 7,5 heures de cours d\'anglais par semaine avec des groupes par niveau' },
        { title: 'Ateliers Sportifs', description: '8 heures d\'ateliers professionnels sur la stratégie, la nutrition et la prévention des blessures' }
      ],
      eliteFootballTraining: 'Entraînement de Football d\'Élite',
      eliteFootballTrainingDesc: 'heures par semaine d\'entraînement intensif dirigé par des entraîneurs officiels de la Fondation Aston Villa, axé sur la technique individuelle, les tactiques d\'équipe et l\'intensité compétitive.',
      hoursTrainingWeekLabel: 'Heures Entraînement/Semaine',
      hoursWorkshopsWeek: 'Heures Ateliers/Semaine',
      professionalWorkshopsInclude: 'Les Ateliers Professionnels Comprennent:',
      workshopTopics: ['Stratégie et tactiques de jeu', 'Nutrition sportive', 'Prévention des blessures', 'Préparation mentale', 'Développement de carrière'],
      ledBy: 'Dirigé par',
      workshopLedBy: 'professionnels certifiés de la Fondation Aston Villa',
      englishLanguageImmersion: 'Immersion en Langue Anglaise',
      dynamicEnglishClasses: 'Cours d\'Anglais Dynamiques',
      hoursPerWeek: 'Heures par semaine:',
      groupSize: 'Taille du groupe:',
      levels: 'Niveaux:',
      differentGroupsBasedOnTest: 'différents groupes basés sur le test initial',
      certificate: 'Certificat:',
      diplomaUponCompletion: 'Diplôme à la fin',
      englishObjective: 'Nos cours d\'anglais utilisent le sport comme véhicule pour l\'acquisition naturelle de la langue, rendant l\'apprentissage engageant et pertinent pour les intérêts des étudiants.',
      englishMethodology: 'Cours d\'anglais dynamiques et axés sur le football conçus pour engager les jeunes athlètes tout en développant de véritables compétences en communication.',
      grammarConversation: 'Grammaire, conversation et vocabulaire technique dans un contexte footballistique',
      smallGroupsTailored: 'Petits groupes adaptés au niveau de chaque étudiant',
      initialLevelTest: 'Test de niveau initial pour assurer un placement correct',
      focusOnOvercomingFears: 'Accent sur le dépassement des peurs de communication et la construction de la confiance',
      dailySchedule: 'Programme Quotidien',
      dailyScheduleDesc: 'Une journée typique au Programme de la Fondation Aston Villa',
      schedule: [
        { time: '7:30', activity: 'Réveil', detail: 'Préparation matinale' },
        { time: '8:00', activity: 'Petit-déjeuner', location: 'Réfectoire' },
        { time: '9:00', activity: 'Cours d\'Anglais', detail: 'Groupes par niveau', location: 'Salles de classe' },
        { time: '11:00', activity: 'Entraînement Matinal', detail: 'Travail technique et tactique', location: 'Terrains d\'entraînement' },
        { time: '13:30', activity: 'Déjeuner', location: 'Réfectoire' },
        { time: '15:00', activity: 'Entraînement Après-midi', detail: 'Préparation des matchs et jeux', location: 'Terrains d\'entraînement' },
        { time: '17:30', activity: 'Temps Libre', detail: 'Piscine, salle de jeux ou repos' },
        { time: '19:00', activity: 'Dîner', location: 'Réfectoire' },
        { time: '20:00', activity: 'Activités du Soir', detail: 'Films de football, activités d\'équipe' },
        { time: '22:00', activity: 'Extinction des Feux' }
      ],
      whatsIncluded: 'Ce Qui Est Inclus',
      whatsIncludedDesc: 'Tout ce dont vous avez besoin pour une expérience inoubliable',
      included: [
        'Hébergement en pension complète à Oakham School',
        'Kit d\'entraînement officiel Aston Villa',
        'Jusqu\'à 20 heures d\'entraînement de football par semaine',
        'Jusqu\'à 7,5 heures de cours d\'anglais',
        '8 heures d\'ateliers sportifs professionnels',
        'Excursion au stade de Premier League',
        'Rapport d\'évaluation complet et diplôme',
        'Toutes les activités et excursions',
        'Accès aux installations sportives',
        'Supervision 24/7 et assistance médicale'
      ],
      pricingDates: 'Prix et Dates',
      pricingDatesDesc: 'Choisissez la durée de votre programme de la Fondation Aston Villa',
      week: 'Semaine',
      weeks: 'Semaines',
      fullBoardTrainingKit: 'Pension complète + kit d\'entraînement inclus',
      upTo20HoursTraining: 'Jusqu\'à 20 heures d\'entraînement par semaine',
      englishClasses: 'Cours d\'anglais (7,5 hrs/semaine)',
      officialTrainingKit: 'Kit d\'entraînement officiel Aston Villa',
      stadiumExcursion: 'Excursion au stade',
      sportsWorkshops: 'Ateliers sportifs (8 hrs/semaine)',
      competitiveMatches: 'Matchs compétitifs',
      completeEvaluationReport: 'Rapport d\'évaluation complet',
      mostPopular: 'PLUS POPULAIRE',
      startDates2026: 'Dates de Début 2026',
      registrationFee: 'Frais d\'inscription:',
      initialDeposit: 'Dépôt initial:',
      freeCancellationUntil: '(assurance annulation gratuite incluse — réservez avant le 1er mai)',
      experienceProgram: 'Vivez le Programme',
      experienceProgramDesc: 'Regardez nos joueurs en action aux séances d\'entraînement de la Fondation Aston Villa'
    },
    englishImmersion: {
      badge: 'Immersion Complète 24/7',
      heroTitle: 'Expérience d\'Immersion Totale en Anglais',
      heroSubtitle: 'Chaque moment au camp est une opportunité d\'apprendre l\'anglais naturellement - de la salle de classe au terrain, des repas aux activités',
      countries: 'Plus de 30 Pays',
      englishEnvironment: '100% Environnement Anglais',
      teflCertified: 'Enseignants Certifiés TEFL',
      viewPrograms: 'Voir les Programmes',
      signUpNow: 'S\'inscrire Maintenant',
      moreThanClasses: 'Plus que de Simples Cours d\'Anglais',
      moreThanClassesDesc1: 'Dans notre camp d\'été, l\'anglais est au centre de toute l\'expérience. Toutes les activités, à l\'intérieur comme à l\'extérieur de la salle de classe, sont soigneusement conçues pour offrir une immersion linguistique complète dans un environnement dynamique et motivant.',
      moreThanClassesDesc2: 'Il ne s\'agit pas seulement de cours d\'anglais optionnels - c\'est un programme d\'immersion en anglais 24/7 où chaque moment devient une opportunité d\'apprentissage naturel.',
      learningQuote: '"L\'apprentissage se fait progressivement, naturellement, et presque sans s\'en rendre compte, tout en profitant d\'un été inoubliable."',
      immersionTitle: 'Immersion en Anglais 24/7',
      immersionDesc: 'Chaque aspect de la vie du camp est conçu pour vous immerger en anglais du matin au soir',
      classroomTeaching: '8-12 Heures d\'Enseignement en Classe',
      classroomTeachingDesc: 'Cours d\'anglais professionnels par semaine avec des enseignants certifiés TEFL',
      footballWorkshops: 'Ateliers de Football en Anglais',
      footballWorkshopsDesc: 'Tous les ateliers liés au football sont entièrement en anglais',
      clubPresentations: 'Présentations de Clubs en Anglais',
      clubPresentationsDesc: 'Présentations de clubs professionnels et d\'académies en anglais',
      videoAnalysis: 'Analyse Vidéo en Anglais',
      videoAnalysisDesc: 'Séances d\'entraînement et analyse de matchs en anglais',
      trainingSessions: 'Séances d\'Entraînement en Anglais',
      trainingSessionsDesc: 'Tout le coaching et l\'entraînement sont dispensés en anglais',
      internationalEnvironment: 'Environnement International',
      internationalEnvironmentDesc: 'Participants de plus de 30 pays créant une communication naturelle en anglais',
      englishMonitors: 'Moniteurs Anglophones 24/7',
      englishMonitorsDesc: 'Le personnel et les moniteurs communiquent toujours en anglais',
      freeTimeActivities: 'Activités de Temps Libre en Anglais',
      freeTimeActivitiesDesc: 'Toutes les activités de loisirs et de divertissement sont en anglais',
      professionalClasses: 'Cours d\'Anglais Professionnels',
      professionalClassesDesc: 'Enseignants certifiés TEFL dispensant 4,5 heures d\'instruction professionnelle quotidienne',
      classSchedule: 'Horaire des Cours',
      hoursPerDay: '4,5 heures par jour (lundi à vendredi)',
      teflCertifiedTeachers: 'Enseignants certifiés TEFL avec des qualifications professionnelles',
      footballFocusedContext: 'Contexte axé sur le football combinant apprentissage et plaisir',
      communicativeApproach: 'Approche 100% communicative - naturelle dès le premier jour',
      teachingMethodology: 'Méthodologie d\'Enseignement',
      teachingMethodologyDesc1: 'Notre approche est 100% communicative, privilégiant l\'interaction verbale à travers des activités pratiques et des situations de la vie réelle.',
      teachingMethodologyDesc2: 'Adaptée aux jeunes de différents âges, niveaux et nationalités, garantissant que chacun progresse à son propre rythme.',
      outsideClassroom: 'Activités Hors de la Classe',
      outsideClassroomDesc: 'Une variété d\'activités renforcent ce qui a été appris pendant les leçons:',
      rolePlayingGames: 'Jeux de rôle et simulations de la vie quotidienne',
      teamworkExercises: 'Exercices de travail d\'équipe et de résolution de problèmes',
      funCreativeActivities: 'Activités amusantes et créatives',
      practicalActivities: 'Activités pratiques et situations de la vie réelle',
      sportsContinuousLearning: 'Le Sport comme Apprentissage Continu',
      duringTraining: 'Pendant l\'Entraînement',
      duringTrainingDesc: 'Les entraîneurs communiquent en anglais, utilisant un vocabulaire technique et quotidien qui renforce ce que les étudiants ont appris en classe.',
      dailyCampLife: 'Dans la Vie Quotidienne du Camp',
      dailyCampLifeDesc: 'Repas, ateliers, activités et temps libre - tout est en anglais, intégrant la langue dans chaque moment de la journée.',
      multiculturalSpace: 'Espace Multiculturel',
      multiculturalSpaceDesc1: 'Le camp est un espace multiculturel, où des jeunes de différents pays et cultures vivent ensemble.',
      multiculturalSpaceDesc2: 'Avec des participants de plus de 30 pays, cette diversité enrichit l\'expérience et renforce l\'utilisation de l\'anglais comme langue commune, favorisant l\'apprentissage dans un contexte authentique, inclusif et motivant.',
      naturalCommunication: 'Communication Naturelle en Anglais',
      naturalCommunicationDesc: 'Quand des joueurs d\'Italie, d\'Espagne, d\'Allemagne, des Pays-Bas et d\'ailleurs se réunissent, l\'anglais devient le pont naturel - forçant et encourageant la conversation quotidienne de manière authentique.',
      ourGoal: 'Notre Objectif pour Chaque Participant',
      ourGoalDesc: 'À la fin du camp, vous aurez réalisé des progrès tangibles dans votre parcours en anglais',
      improveEnglish: 'Améliorer le niveau d\'anglais de manière tangible',
      gainConfidence: 'Gagner en confiance dans la communication',
      developIntercultural: 'Développer des compétences interculturelles',
      bePartOfCommunity: 'Faire partie d\'une communauté internationale',
      completeImmersion: 'Expérience d\'Immersion Complète',
      completeImmersionDesc: 'À la fin du camp, les étudiants auront vécu une véritable expérience d\'immersion linguistique, se seront fait des amis du monde entier et auront fait des progrès significatifs dans leur maîtrise de l\'anglais...',
      safeEnvironment: 'Le tout dans un environnement sûr, sportif et stimulant.',
      readyToExperience: 'Prêt à Vivre l\'Immersion Totale en Anglais?',
      readyToExperienceDesc: 'Rejoignez-nous pour un été inoubliable de football et d\'apprentissage des langues',
      viewProgramsPrices: 'Voir les Programmes et Prix'
    },
    technology: {
      badge: 'Technologie de Performance Avancée',
      heroTitle: 'Technologie et Analyse',
      heroSubtitle: 'Nous utilisons une technologie de pointe pour améliorer le développement des joueurs, fournir des retours détaillés et mesurer l\'amélioration tout au long de l\'expérience du camp',
      veoCamera: 'Caméra Veo',
      veoCameraTagline: 'Enregistrement Vidéo Professionnel et Streaming en Direct',
      videoAnalysis: 'Analyse Vidéo',
      videoAnalysisTagline: 'Sessions Interactives de Revue de Performance',
      draftApp: 'The Draft App',
      draftAppTagline: 'Évaluation des Joueurs par IA',
      evaluationReports: 'Rapports d\'Évaluation',
      evaluationReportsTagline: 'Rapports Personnalisés Complets',
      veoCameraSystem: 'Système de Caméra Veo',
      veoCameraSystemDesc: 'Toutes les séances d\'entraînement et les matchs sont enregistrés avec des caméras professionnelles Veo, fournissant des images en qualité HD pour le streaming en direct et l\'analyse détaillée post-session.',
      veoFeature1: 'Enregistre toutes les séances d\'entraînement et matchs en qualité HD',
      veoFeature2: 'Capacité de streaming en direct pour que les familles regardent de n\'importe où',
      veoFeature3: 'Suivi automatique des joueurs et angles de caméra tactiques',
      veoFeature4: 'Stockage cloud pour un accès facile à toutes les images',
      veoFeature5: 'Utilisé pour l\'analyse post-match et post-entraînement',
      liveStreamingFamilies: 'Streaming en Direct pour les Familles',
      liveStreamingFamiliesDesc: 'Les parents et les membres de la famille peuvent regarder les séances d\'entraînement et les matchs en direct de n\'importe où dans le monde, restant connectés à l\'expérience de leur joueur.',
      professionalRecording: 'Enregistrement Professionnel',
      professionalRecordingDesc: 'Chaque moment capturé en qualité de diffusion avec suivi automatique des joueurs et angles tactiques.',
      quality: 'Qualité',
      streaming: 'Streaming',
      storage: 'Stockage',
      access: 'Accès',
      professionalVideoAnalysis: 'Analyse Vidéo Professionnelle',
      professionalVideoAnalysisDesc: 'Plusieurs fois par semaine, un analyste de football professionnel examine les images avec les joueurs et les entraîneurs dans des sessions interactives où les joueurs participent activement.',
      analysisFeature1: 'Plusieurs sessions d\'analyse professionnelle par semaine',
      analysisFeature2: 'Sessions interactives avec participation active des joueurs',
      analysisFeature3: 'Évaluation vidéo pré-camp avec appel familial inclus',
      analysisFeature4: 'Focus sur les domaines individuels d\'amélioration',
      analysisFeature5: 'Analyse tactique, technique et positionnelle',
      analysisFeature6: 'Retour de l\'entraîneur et de l\'analyste en temps réel',
      personalizedFocus: 'Focus Personnalisé',
      personalizedFocusDesc: 'Chaque joueur reçoit une attention individuelle, avec une analyse adaptée à sa position spécifique, son style de jeu et ses domaines d\'amélioration.',
      interactiveAnalysis: 'Sessions d\'Analyse Interactives',
      preCampEvaluation: 'Évaluation Pré-Camp',
      preCampEvaluationDesc: 'Envoyez une vidéo avant le début du camp. Recevez un appel personnalisé avec la famille présente pour discuter des domaines de focus et des objectifs d\'amélioration.',
      duringCampSessions: 'Sessions Pendant le Camp',
      duringCampSessionsDesc: 'Plusieurs sessions hebdomadaires avec des analystes professionnels examinant vos images, expliquant les améliorations et analysant différentes situations de jeu.',
      activeParticipation: 'Participation Active',
      activeParticipationDesc: 'Les joueurs participent activement aux sessions, discutant des tactiques, posant des questions et comprenant leur performance en détail.',
      comprehensiveReports: 'Rapports d\'Évaluation Complets',
      comprehensiveReportsDesc: 'À la fin du camp, chaque joueur reçoit un rapport d\'évaluation personnalisé complet',
      reportIncludes: 'Votre Rapport Comprend:',
      technicalSkills: 'Évaluation des Compétences Techniques',
      technicalSkillsDesc: 'Évaluation détaillée du contrôle du ballon, des passes, des tirs et des dribbles',
      tacticalUnderstanding: 'Compréhension Tactique',
      tacticalUnderstandingDesc: 'Analyse du positionnement, de la prise de décision et de l\'intelligence de jeu',
      physicalPerformance: 'Performance Physique',
      physicalPerformanceDesc: 'Vitesse, endurance, force et capacités athlétiques',
      mentalSocialSkills: 'Compétences Mentales et Sociales',
      mentalSocialSkillsDesc: 'Leadership, travail d\'équipe, attitude et capacité à être entraîné',
      recommendations: 'Recommandations',
      recommendationsDesc: 'Domaines spécifiques sur lesquels se concentrer et suggestions d\'entraînement pour un développement continu',
      sampleReport: 'Exemple de Rapport',
      multiPageAnalysis: 'Analyse complète sur plusieurs pages',
      reportDelivered: 'Rapport d\'évaluation professionnel livré numériquement',
      viewFullReport: 'Voir le Rapport Complet',
      downloadSampleReport: 'Télécharger l\'Exemple de Rapport (PDF)',
      aiPoweredAssessment: 'The Draft App: Évaluation par IA',
      aiPoweredAssessmentDesc: 'Nous utilisons une technologie IA de pointe pour évaluer les joueurs sur différentes capacités physiques et techniques avant, pendant et après le camp',
      howItWorks: 'Comment Ça Marche',
      downloadApp: 'Téléchargez l\'App',
      downloadAppDesc: 'Disponible pour les appareils iOS et Android',
      setupTestScene: 'Configurez la Scène de Test',
      setupTestSceneDesc: 'Utilisez des cônes de football pour les dribbles, un but pour les tirs puissants et d\'autres configurations simples',
      completeTests: 'Complétez les Tests',
      completeTestsDesc: 'Les modèles IA évaluent votre performance en utilisant la vision par ordinateur',
      getResults: 'Obtenez les Résultats',
      getResultsDesc: 'Recevez des benchmarks adaptés à l\'âge et suivez l\'amélioration au fil du temps',
      whatWeMeasure: 'Ce Que Nous Mesurons',
      appPreview: 'Aperçu de l\'Application',
      draftFeature1: 'Évaluation des capacités physiques par IA',
      draftFeature2: 'Évaluation des compétences techniques par vision par ordinateur',
      draftFeature3: 'Benchmarking de performance adapté à l\'âge',
      draftFeature4: 'Les tests incluent dribbles, tirs puissants et plus',
      draftFeature5: 'Configuration facile avec juste des cônes de football et un but',
      draftFeature6: 'Suivez les progrès avant, pendant et après le camp',
      trackProgress: 'Suivez Vos Progrès',
      trackProgressDesc: 'Testez-vous avant le camp, pendant le camp et après le camp pour voir des améliorations mesurables de vos capacités. L\'IA tient compte de votre âge et fournit des benchmarks personnalisés.',
      objectiveAssessment: 'Évaluation Objective Basée sur les Données',
      objectiveAssessmentDesc: 'La technologie IA élimine la subjectivité et fournit des mesures précises et cohérentes de vos capacités',
      experienceTechnology: 'Découvrez l\'Entraînement Amélioré par la Technologie',
      experienceTechnologyDesc: 'Rejoignez un camp où la technologie de pointe rencontre le coaching professionnel pour un développement maximal des joueurs',
      viewProgramsPrices: 'Voir les Programmes et Prix',
      signUpNow: 'S\'inscrire Maintenant'
    },
    aboutOakham: {
      heroTitle: 'Oakham School',
      heroDesc: 'Un prestigieux internat britannique offrant des installations de classe mondiale pour nos camps de football',
      perfectLocation: 'Emplacement Parfait',
      locationTown: 'Oakham',
      locationRegion: 'Rutland, Angleterre',
      locationFromLondon: '2 heures au nord de Londres',
      nearestAirports: 'Aéroports les Plus Proches',
      airports: [
        'Aéroport d\'East Midlands (45 min)',
        'Aéroport de Birmingham (1 heure)'
      ],
      accommodation: 'Hébergement',
      rooms: 'Chambres',
      roomTypes: 'Chambres partagées (doubles ou triples), chambres individuelles limitées disponibles',
      bathrooms: 'Salles de bain:',
      bathroomsDesc: 'Installations partagées à chaque étage',
      amenities: 'Commodités',
      amenitiesList: [
        'Supervision et sécurité 24/7',
        'Service de nettoyage quotidien des chambres',
        'Changement de draps et serviettes',
        'WiFi gratuit partout',
        'Espaces communs avec TV et jeux',
        'Service de blanchisserie disponible'
      ],
      dining: 'Restauration',
      mealsNutrition: 'Repas et Nutrition',
      meals: 'Repas:',
      mealsDesc: 'Trois repas nutritifs par jour plus collations',
      cuisine: 'Cuisine:',
      cuisineDesc: 'Menu international avec classiques britanniques',
      dietary: 'Diététique:',
      dietaryDesc: 'Tous les régimes alimentaires sont pris en charge',
      features: 'Caractéristiques',
      diningFeatures: [
        'Équipe de restauration professionnelle',
        'Ingrédients frais d\'origine locale',
        'Nutrition équilibrée pour athlètes',
        'Options végétariennes et véganes',
        'Repas sans allergènes disponibles',
        'Salle à manger avec architecture impressionnante'
      ],
      worldClassFacilities: 'Installations de Classe Mondiale',
      sportsFacilities: 'Installations Sportives',
      sportsFeatures: [
        'Plusieurs terrains en gazon naturel',
        'Terrain en gazon artificiel grandeur nature',
        'Piscine de taille olympique',
        'Gymnase entièrement équipé',
        'Salle de sport intérieure',
        'Vestiaires et douches'
      ],
      academicFacilities: 'Installations Académiques',
      academicFeatures: [
        'Salles de classe modernes pour les cours d\'anglais',
        'Laboratoires de langues',
        'Bibliothèque et espaces d\'étude',
        'Salle d\'analyse vidéo'
      ],
      recreational: 'Récréatives',
      recreationalFeatures: [
        'Salle de jeux avec billard et ping-pong',
        'Salons TV',
        'Zones de jeux PlayStation',
        'Espaces de loisirs extérieurs'
      ],
      safetySecurity: 'Sécurité et Protection',
      safetyDesc: 'La sécurité de votre enfant est notre priorité absolue. Oakham offre un environnement sécurisé et supervisé avec une présence du personnel 24/7, une surveillance CCTV et des procédures de protection complètes.',
      staffSupervision: 'Supervision du Personnel',
      townEnvironment: 'Environnement de la Ville',
      safe: 'Sûr',
      medicalCare: 'Soins Médicaux',
      onSite: 'Sur Place'
    },
    prices: {
      heroTitle: 'Prix et Dates',
      heroSubtitle: 'Durées flexibles pour s\'adapter à votre emploi du temps. Tous les prix incluent l\'hébergement, les repas, l\'entraînement et les cours d\'anglais.',
      highPerformanceClinic: 'Clinique Haute Performance',
      chooseDuration: 'Choisissez la durée parfaite pour votre expérience de camp d\'été',
      week: 'Semaine',
      weeks: 'Semaines',
      oneWeek: '1 Semaine',
      twoWeeks: '2 Semaines',
      threeWeeks: '3 Semaines',
      fourWeeks: '4 Semaines',
      fullBoardIncluded: 'Pension complète incluse',
      mostPopular: 'PLUS POPULAIRE',
      signUpNow: 'S\'inscrire Maintenant',
      startDates2026: 'Dates de Début 2026',
      available: 'Disponible',
      soldOut: 'Complet',
      spotsLeft: 'places restantes',
      onlyXSpotsLeft: 'Plus que {x} places!',
      limitedAvailability: 'Disponibilité Limitée',
      clinicSoldOut: 'Clinic — Complet',
      astonVillaAvailable: 'Aston Villa — {x} places',
      astonVillaProgram: 'Programme Fondation Aston Villa',
      astonVillaDesc: 'Expérience officielle d\'entraînement de la Fondation Aston Villa',
      fullBoardTrainingKit: 'Pension complète + kit d\'entraînement inclus',
      registrationInfo: 'Informations d\'Inscription',
      registrationFee: 'Frais d\'Inscription',
      initialDeposit: 'Dépôt Initial',
      freeCancellation: 'Assurance annulation gratuite incluse (réservez avant le 1er mai)',
      paymentOptions: 'Options de Paiement',
      gbpEurUsd: 'GBP, EUR ou USD',
      paymentsAccepted: 'Paiements acceptés en GBP, EUR ou USD aux taux de change actuels.',
      groupDiscounts: 'Réductions de groupe disponibles pour les membres de la famille ou les amis. Contactez-nous pour plus de détails.',
      whatsIncluded: 'Ce Qui Est Inclus dans Tous les Prix',
      accommodationTitle: 'Hébergement',
      fullBoard: 'Pension complète (3 repas + collations)',
      sharedAccommodation: 'Hébergement partagé',
      linenTowels: 'Linge de lit et serviettes',
      supervision: 'Supervision 24/7',
      trainingEducation: 'Entraînement et Éducation',
      dailyTrainingSessions: '2 séances d\'entraînement quotidiennes',
      englishLessons: 'Cours d\'anglais (4,5 hrs/jour)',
      uefaCoaches: 'Entraîneurs licenciés UEFA',
      evaluationReport: 'Rapport d\'évaluation',
      activitiesExtras: 'Activités et Extras',
      stadiumExcursion: 'Excursion au stade',
      facilitiesAccess: 'Accès à toutes les installations',
      eveningActivities: 'Activités du soir',
      freeWifi: 'WiFi gratuit',
      readyToSecure: 'Prêt à réserver votre place?',
      // Clinic features
      clinicFeatures: {
        '20hours': '20+ heures d\'entraînement de football',
        '40hours': '40+ heures d\'entraînement de football',
        '60hours': '60+ heures d\'entraînement de football',
        '80hours': '80+ heures d\'entraînement de football',
        'english45': '4,5 heures d\'anglais par jour',
        'fullBoard': 'Hébergement en pension complète',
        'stadiumExcursion': 'Excursion au stade',
        'stadiumExcursions2': '2 excursions aux stades',
        'stadiumExcursions3': '3 excursions aux stades',
        'stadiumExcursions4': '4 excursions aux stades',
        'tournament': 'Tournoi de fin de camp',
        'analysisReport': 'Rapport d\'analyse de performance',
        'completeAnalysis': 'Analyse complète de performance',
        'certificate': 'Certificat de fin de stage'
      },
      // Aston Villa features
      villaFeatures: {
        'officialCoaching': 'Entraînement officiel Aston Villa',
        '20hours': '20+ heures d\'entraînement',
        '40hours': '40+ heures d\'entraînement',
        'villaParkVisit': 'Visite du stade Villa Park',
        'fullKit': 'Kit complet Aston Villa',
        'evaluation': 'Évaluation de performance',
        'certificate': 'Certificat de fin de stage'
      }
    },
    contact: {
      heroTitle: 'Contactez-Nous',
      heroSubtitle: 'Vous avez des questions sur nos programmes? Nous sommes là pour vous aider à trouver l\'expérience parfaite de camp de football.',
      sendMessage: 'Envoyez-Nous un Message',
      fullName: 'Nom Complet',
      emailAddress: 'Adresse Email',
      phoneNumber: 'Numéro de Téléphone',
      interestedIn: 'Intéressé Par',
      selectProgram: 'Sélectionnez un programme',
      highPerformanceClinic: 'Clinique Haute Performance',
      astonVillaProgram: 'Programme Aston Villa',
      bothPrograms: 'Les Deux Programmes',
      generalInquiry: 'Demande Générale',
      message: 'Message',
      messagePlaceholder: 'Parlez-nous de votre demande, de l\'âge du joueur, des dates préférées ou de toute question...',
      sendMessageBtn: 'Envoyer le Message',
      sending: 'Envoi en cours...',
      successMessage: 'Merci pour votre message! Nous vous répondrons bientôt.',
      errorMessage: 'Une erreur s\'est produite lors de l\'envoi de votre message. Veuillez réessayer.',
      emailUs: 'Écrivez-Nous',
      emailResponse: 'Nous répondons généralement sous 24 heures',
      callUs: 'Appelez-Nous',
      callHours: 'Lundi - Vendredi: 9h - 18h GMT',
      visitUs: 'Visitez-Nous',
      quickLinks: 'Liens Rapides',
      viewPricesDates: 'Voir les Prix et Dates',
      clinicProgramDetails: 'Détails du Programme Clinique',
      aboutOakhamSchool: 'À Propos d\'Oakham School',
      signUpNow: 'S\'inscrire Maintenant'
    },
    signUp: {
      heroTitle: 'S\'inscrire Maintenant',
      heroSubtitle: 'Commencez votre parcours vers l\'excellence footballistique. Remplissez le formulaire ci-dessous pour vous inscrire pour l\'été 2026.',
      parentGuardianInfo: 'Informations du Parent/Tuteur',
      fullName: 'Nom Complet',
      emailAddress: 'Adresse Email',
      phoneNumber: 'Numéro de Téléphone',
      playerInfo: 'Informations du Joueur',
      playerFullName: 'Nom Complet du Joueur',
      age: 'Âge',
      gender: 'Genre',
      selectGender: 'Sélectionnez le genre',
      male: 'Masculin',
      female: 'Féminin',
      programSelection: 'Sélection du Programme',
      program: 'Programme',
      selectProgram: 'Sélectionnez un programme',
      highPerformanceClinic: 'Clinique Haute Performance',
      astonVillaProgram: 'Programme Aston Villa',
      duration: 'Durée',
      selectDuration: 'Sélectionnez la durée',
      selectProgramFirst: 'Sélectionnez d\'abord un programme',
      startDate: 'Date de Début',
      selectStartDate: 'Sélectionnez la date de début',
      additionalInfo: 'Informations Supplémentaires',
      medicalConditions: 'Conditions Médicales ou Allergies',
      medicalPlaceholder: 'Veuillez lister toute condition médicale, allergies ou médicaments',
      dietaryRequirements: 'Exigences Alimentaires',
      dietaryPlaceholder: 'Végétarien, végétalien, halal, allergies, etc.',
      emergencyContact: 'Contact d\'Urgence (si différent du parent)',
      emergencyPlaceholder: 'Nom et numéro de téléphone',
      whatHappensNext: 'Que Se Passe-t-il Ensuite?',
      step1: 'Vous recevrez un email de confirmation sous 24 heures',
      step2: 'Nous vous enverrons les documents d\'inscription et les détails de paiement',
      step3: 'Complétez le paiement pour réserver votre place',
      step4: 'Recevez le pack de bienvenue avec les détails du camp 4 semaines avant le début',
      completeRegistration: 'Compléter l\'Inscription',
      submitting: 'Envoi en cours...',
      successMessage: 'Merci pour votre inscription! Nous vous contacterons bientôt avec les détails de confirmation.',
      errorMessage: 'Une erreur s\'est produite lors du traitement de votre inscription. Veuillez réessayer.',
      termsAgreement: 'En soumettant ce formulaire, vous acceptez nos conditions générales et notre politique de confidentialité.'
    },
    legal: {
      termsTitle: 'Conditions Générales',
      privacyTitle: 'Politique de Confidentialité',
      cookieTitle: 'Politique de Cookies',
      lastUpdated: 'Dernière Mise à Jour:',
      introduction: '1. Introduction',
      termsPlaceholder: 'Veuillez copier le contenu des Conditions Générales depuis:',
      privacyPlaceholder: 'Veuillez copier le contenu de la Politique de Confidentialité depuis:',
      cookiePlaceholder: 'Veuillez copier le contenu de la Politique de Cookies depuis:',
      termsIncludes: 'Cette page doit inclure toutes les conditions générales couvrant:',
      privacyIncludes: 'Cette page doit inclure toutes les informations de politique de confidentialité couvrant:',
      cookieIncludes: 'Cette page doit inclure toutes les informations de politique de cookies couvrant:',
      servicesOffered: 'Services offerts',
      bookingPayment: 'Conditions de réservation et de paiement',
      cancellationPolicies: 'Politiques d\'annulation',
      campRules: 'Règles et règlements du camp',
      liabilityLimitations: 'Limitations de responsabilité',
      userResponsibilities: 'Responsabilités de l\'utilisateur',
      personalDataCollected: 'Quelles données personnelles sont collectées',
      dataUsedStored: 'Comment les données sont utilisées et stockées',
      dataRetention: 'Périodes de conservation des données',
      userRights: 'Droits de l\'utilisateur (accès, modification, suppression)',
      dataSecurity: 'Mesures de sécurité des données',
      thirdPartySharing: 'Partage de données avec des tiers',
      contactInfo: 'Coordonnées pour les demandes de données',
      whatCookiesAre: 'Ce que sont les cookies et comment ils fonctionnent',
      typesOfCookies: 'Types de cookies utilisés sur le site web',
      purposeOfCookies: 'Objectif de chaque type de cookie',
      manageCookies: 'Comment gérer les préférences de cookies',
      thirdPartyCookies: 'Cookies tiers',
      cookieConsent: 'Mécanismes de consentement aux cookies',
      campSpecificPolicies: '2. Politiques Spécifiques au Camp',
      campSpecificDesc: 'Inclure des détails sur les dépôts, les calendriers de paiement, les politiques de remboursement et tout terme spécifique au programme.',
      codeOfConduct: '3. Code de Conduite',
      codeOfConductDesc: 'Inclure les règles du camp concernant le comportement, la sécurité, les articles interdits et les conséquences des violations.',
      dataCollection: '2. Collecte de Données',
      dataCollectionDesc: 'Inclure des détails sur les types d\'informations personnelles collectées (noms, dates de naissance, coordonnées, informations médicales, etc.).',
      yourRights: '3. Vos Droits',
      yourRightsDesc: 'Inclure des informations sur les droits RGPD et comment les utilisateurs peuvent les exercer.',
      typesOfCookiesSection: '2. Types de Cookies',
      typesOfCookiesDesc: 'Inclure des détails sur les cookies essentiels, les cookies de performance, les cookies fonctionnels et les cookies de ciblage/publicité.',
      managingCookies: '3. Gestion des Cookies',
      managingCookiesDesc: 'Inclure des informations sur comment les utilisateurs peuvent contrôler et supprimer les cookies via les paramètres de leur navigateur.',
      adminNoteTerms: 'Note à l\'Administrateur: Veuillez remplacer ce contenu de substitution par les Conditions Générales réelles. Le contenu doit être copié dans son intégralité pour assurer la conformité légale et l\'exactitude.',
      adminNotePrivacy: 'Note à l\'Administrateur: Veuillez remplacer ce contenu de substitution par la Politique de Confidentialité réelle. Le contenu doit être copié dans son intégralité pour assurer la conformité légale avec le RGPD et autres réglementations de confidentialité.',
      adminNoteCookie: 'Note à l\'Administrateur: Veuillez remplacer ce contenu de substitution par la Politique de Cookies réelle. Le contenu doit être copié dans son intégralité pour assurer la conformité légale avec les lois et réglementations européennes sur les cookies.'
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  return value || key;
};
